import { jsx as m, jsxs as M, Fragment as en } from "react/jsx-runtime";
import { useState as ee, useCallback as O, useRef as R, createContext as at, useContext as ct, useLayoutEffect as tn, useEffect as B, useMemo as Je } from "react";
import { create as Bn, useStore as Vn } from "zustand";
import { createPortal as Kn } from "react-dom";
const nn = ["shift", "alt", "meta", "mod", "ctrl", "control"], $n = {
  esc: "escape",
  return: "enter",
  left: "arrowleft",
  right: "arrowright",
  up: "arrowup",
  down: "arrowdown",
  ShiftLeft: "shift",
  ShiftRight: "shift",
  AltLeft: "alt",
  AltRight: "alt",
  MetaLeft: "meta",
  MetaRight: "meta",
  OSLeft: "meta",
  OSRight: "meta",
  ControlLeft: "ctrl",
  ControlRight: "ctrl"
};
function Q(e) {
  return ($n[e.trim()] || e.trim()).toLowerCase().replace(/key|digit|numpad/, "");
}
function rn(e) {
  return nn.includes(e);
}
function Ve(e, t = ",") {
  return e.toLowerCase().split(t);
}
function Ke(e, t = "+", n = ">", r = !1, i, a) {
  let l = [], d = !1;
  e = e.trim(), e.includes(n) ? (d = !0, l = e.toLocaleLowerCase().split(n).map((u) => Q(u))) : l = e.toLocaleLowerCase().split(t).map((u) => Q(u));
  const c = {
    alt: l.includes("alt"),
    ctrl: l.includes("ctrl") || l.includes("control"),
    shift: l.includes("shift"),
    meta: l.includes("meta"),
    mod: l.includes("mod"),
    useKey: r
  }, s = l.filter((u) => !nn.includes(u));
  return {
    ...c,
    keys: s,
    description: i,
    isSequence: d,
    hotkey: e,
    metadata: a
  };
}
typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.code !== void 0 && on([Q(e.code)]);
}), document.addEventListener("keyup", (e) => {
  e.code !== void 0 && an([Q(e.code)]);
})), typeof window < "u" && (window.addEventListener("blur", () => {
  Y.clear();
}), window.addEventListener("contextmenu", () => {
  setTimeout(() => {
    Y.clear();
  }, 0);
}));
const Y = /* @__PURE__ */ new Set();
function st(e) {
  return Array.isArray(e);
}
function Xn(e, t = ",") {
  return (st(e) ? e : e.split(t)).every((n) => Y.has(n.trim().toLowerCase()));
}
function on(e) {
  const t = Array.isArray(e) ? e : [e];
  Y.has("meta") && Y.forEach((n) => {
    rn(n) || Y.delete(n.toLowerCase());
  }), t.forEach((n) => {
    Y.add(n.toLowerCase());
  });
}
function an(e) {
  const t = Array.isArray(e) ? e : [e];
  e === "meta" ? Y.clear() : t.forEach((n) => {
    Y.delete(n.toLowerCase());
  });
}
function Zn(e, t, n) {
  (typeof n == "function" && n(e, t) || n === !0) && e.preventDefault();
}
function Un(e, t, n) {
  return typeof n == "function" ? n(e, t) : n === !0 || n === void 0;
}
const Yn = [
  "input",
  "textarea",
  "select",
  "searchbox",
  "slider",
  "spinbutton",
  "menuitem",
  "menuitemcheckbox",
  "menuitemradio",
  "option",
  "radio",
  "textbox"
];
function _n(e) {
  return cn(e, Yn);
}
function cn(e, t = !1) {
  const { target: n, composed: r } = e;
  let i, a;
  return Gn(n) && r ? (i = e.composedPath()[0] && e.composedPath()[0].tagName, a = e.composedPath()[0] && e.composedPath()[0].role) : (i = n && n.tagName, a = n && n.role), st(t) ? !!(i && t && t.some((l) => l.toLowerCase() === i.toLowerCase() || l === a)) : !!(i && t && t);
}
function Gn(e) {
  return !!e.tagName && !e.tagName.startsWith("-") && e.tagName.includes("-");
}
function qn(e, t) {
  return e.length === 0 && t ? !1 : t ? e.some((n) => t.includes(n)) || e.includes("*") : !0;
}
const Qn = (e, t, n = !1) => {
  const { alt: r, meta: i, mod: a, shift: l, ctrl: d, keys: c, useKey: s } = t, { code: u, key: o, ctrlKey: v, metaKey: p, shiftKey: f, altKey: g } = e, h = Q(u);
  if (s && (c == null ? void 0 : c.length) === 1 && c.includes(o.toLowerCase()))
    return !0;
  if (!(c != null && c.includes(h)) && !["ctrl", "control", "unknown", "meta", "alt", "shift", "os"].includes(h))
    return !1;
  if (!n) {
    if (r !== g && h !== "alt" || l !== f && h !== "shift")
      return !1;
    if (a) {
      if (!p && !v)
        return !1;
    } else if (i !== p && h !== "meta" && h !== "os" || d !== v && h !== "ctrl" && h !== "control")
      return !1;
  }
  return c && c.length === 1 && c.includes(h) ? !0 : c && c.length > 0 ? c.includes(h) ? Xn(c) : !1 : !c || c.length === 0;
}, sn = at(void 0), Jn = () => ct(sn);
function er({ addHotkey: e, removeHotkey: t, children: n }) {
  return /* @__PURE__ */ m(sn.Provider, { value: { addHotkey: e, removeHotkey: t }, children: n });
}
function lt(e, t) {
  return e && t && typeof e == "object" && typeof t == "object" ? Object.keys(e).length === Object.keys(t).length && // @ts-expect-error TS7053
  Object.keys(e).reduce((n, r) => n && lt(e[r], t[r]), !0) : e === t;
}
const ln = at({
  hotkeys: [],
  activeScopes: [],
  // This array has to be empty instead of containing '*' as default, to check if the provider is set or not
  toggleScope: () => {
  },
  enableScope: () => {
  },
  disableScope: () => {
  }
}), tr = () => ct(ln), nr = ({ initiallyActiveScopes: e = ["*"], children: t }) => {
  const [n, r] = ee(e), [i, a] = ee([]), l = O((o) => {
    r((v) => v.includes("*") ? [o] : Array.from(/* @__PURE__ */ new Set([...v, o])));
  }, []), d = O((o) => {
    r((v) => v.filter((p) => p !== o));
  }, []), c = O((o) => {
    r((v) => v.includes(o) ? v.filter((p) => p !== o) : v.includes("*") ? [o] : Array.from(/* @__PURE__ */ new Set([...v, o])));
  }, []), s = O((o) => {
    a((v) => [...v, o]);
  }, []), u = O((o) => {
    a((v) => v.filter((p) => !lt(p, o)));
  }, []);
  return /* @__PURE__ */ m(
    ln.Provider,
    {
      value: { activeScopes: n, hotkeys: i, enableScope: l, disableScope: d, toggleScope: c },
      children: /* @__PURE__ */ m(er, { addHotkey: s, removeHotkey: u, children: t })
    }
  );
};
function rr(e) {
  const t = R(void 0);
  return lt(t.current, e) || (t.current = e), t.current;
}
const yt = (e) => {
  e.stopPropagation(), e.preventDefault(), e.stopImmediatePropagation();
}, or = typeof window < "u" ? tn : B;
function U(e, t, n, r) {
  const i = R(null), a = R(!1), l = Array.isArray(n) ? Array.isArray(r) ? void 0 : r : n, d = st(e) ? e.join(l == null ? void 0 : l.delimiter) : e, c = Array.isArray(n) ? n : Array.isArray(r) ? r : void 0, s = O(t, c ?? []), u = R(s);
  c ? u.current = s : u.current = t;
  const o = rr(l), { activeScopes: v } = tr(), p = Jn();
  return or(() => {
    if ((o == null ? void 0 : o.enabled) === !1 || !qn(v, o == null ? void 0 : o.scopes))
      return;
    let f = [], g;
    const h = (b, P = !1) => {
      var w;
      if (!(_n(b) && !cn(b, o == null ? void 0 : o.enableOnFormTags))) {
        if (i.current !== null) {
          const T = i.current.getRootNode();
          if ((T instanceof Document || T instanceof ShadowRoot) && T.activeElement !== i.current && !i.current.contains(T.activeElement)) {
            yt(b);
            return;
          }
        }
        (w = b.target) != null && w.isContentEditable && !(o != null && o.enableOnContentEditable) || Ve(d, o == null ? void 0 : o.delimiter).forEach((T) => {
          var E, A, k, D;
          if (T.includes((o == null ? void 0 : o.splitKey) ?? "+") && T.includes((o == null ? void 0 : o.sequenceSplitKey) ?? ">")) {
            console.warn(
              `Hotkey ${T} contains both ${(o == null ? void 0 : o.splitKey) ?? "+"} and ${(o == null ? void 0 : o.sequenceSplitKey) ?? ">"} which is not supported.`
            );
            return;
          }
          const S = Ke(
            T,
            o == null ? void 0 : o.splitKey,
            o == null ? void 0 : o.sequenceSplitKey,
            o == null ? void 0 : o.useKey,
            o == null ? void 0 : o.description,
            o == null ? void 0 : o.metadata
          );
          if (S.isSequence) {
            g = setTimeout(() => {
              f = [];
            }, (o == null ? void 0 : o.sequenceTimeoutMs) ?? 1e3);
            const I = S.useKey ? b.key : Q(b.code);
            if (rn(I.toLowerCase()))
              return;
            f.push(I);
            const H = (E = S.keys) == null ? void 0 : E[f.length - 1];
            if (I !== H) {
              f = [], g && clearTimeout(g);
              return;
            }
            f.length === ((A = S.keys) == null ? void 0 : A.length) && (u.current(b, S), g && clearTimeout(g), f = []);
          } else if (Qn(b, S, o == null ? void 0 : o.ignoreModifiers) || (k = S.keys) != null && k.includes("*")) {
            if ((D = o == null ? void 0 : o.ignoreEventWhen) != null && D.call(o, b) || P && a.current)
              return;
            if (Zn(b, S, o == null ? void 0 : o.preventDefault), !Un(b, S, o == null ? void 0 : o.enabled)) {
              yt(b);
              return;
            }
            u.current(b, S), P || (a.current = !0);
          }
        });
      }
    }, y = (b) => {
      b.code !== void 0 && (on(Q(b.code)), ((o == null ? void 0 : o.keydown) === void 0 && (o == null ? void 0 : o.keyup) !== !0 || o != null && o.keydown) && h(b));
    }, x = (b) => {
      b.code !== void 0 && (an(Q(b.code)), a.current = !1, o != null && o.keyup && h(b, !0));
    }, L = i.current || (l == null ? void 0 : l.document) || document;
    return L.addEventListener("keyup", x, l == null ? void 0 : l.eventListenerOptions), L.addEventListener("keydown", y, l == null ? void 0 : l.eventListenerOptions), p && Ve(d, o == null ? void 0 : o.delimiter).forEach((b) => {
      p.addHotkey(
        Ke(
          b,
          o == null ? void 0 : o.splitKey,
          o == null ? void 0 : o.sequenceSplitKey,
          o == null ? void 0 : o.useKey,
          o == null ? void 0 : o.description,
          o == null ? void 0 : o.metadata
        )
      );
    }), () => {
      L.removeEventListener("keyup", x, l == null ? void 0 : l.eventListenerOptions), L.removeEventListener("keydown", y, l == null ? void 0 : l.eventListenerOptions), p && Ve(d, o == null ? void 0 : o.delimiter).forEach((b) => {
        p.removeHotkey(
          Ke(
            b,
            o == null ? void 0 : o.splitKey,
            o == null ? void 0 : o.sequenceSplitKey,
            o == null ? void 0 : o.useKey,
            o == null ? void 0 : o.description,
            o == null ? void 0 : o.metadata
          )
        );
      }), f = [], g && clearTimeout(g);
    };
  }, [d, o, v]), i;
}
const un = "WEAVE_TIMELINE_HOTKEYS_SCOPE", ir = 16;
function le(e, t, n) {
  if (e <= t) return 0;
  const r = ir / n;
  return e - t + r;
}
function ar(e, t, n) {
  return {
    start: e,
    end: Math.min(e + t, n)
  };
}
function cr(e, t, n) {
  return t + e / n;
}
const sr = 80;
function lr(e) {
  const t = 1 / e;
  return [
    [5 * t, t],
    // labels every 5 frames,  minor every 1 frame
    [10 * t, 5 * t],
    // labels every 10 frames, minor every 5 frames
    [1, 10 * t],
    // labels every 1s,        minor every 10 frames
    [5, 1],
    // labels every 5s,        minor every 1s
    [10, 5],
    // labels every 10s,       minor every 5s
    [30, 10],
    // labels every 30s,       minor every 10s
    [60, 30],
    // labels every 1min,      minor every 30s
    [300, 60],
    // labels every 5min,      minor every 1min
    [600, 300]
    // labels every 10min,     minor every 5min
  ];
}
function ur(e, t) {
  const n = lr(t);
  let r = n[n.length - 1];
  for (const d of n)
    if (d[0] * e >= sr) {
      r = d;
      break;
    }
  const [i, a] = r, l = a < 1;
  return { interval: a, majorInterval: i, showFrames: l };
}
function dr(e, t, n, r, i) {
  const a = [], l = Math.round(r * i), d = Math.ceil(e / n) * n;
  for (let c = d; c <= t; c += n) {
    const s = Math.round(c * i) / i, o = Math.round(s * i) % l === 0;
    a.push({
      time: s,
      isMajor: o,
      label: o ? fr(s, i) : void 0
    });
  }
  return a;
}
function fr(e, t) {
  const n = Math.round(e * t), r = Math.round(t), i = Math.floor(n / r), a = n - i * r, l = Math.floor(i / 3600), d = Math.floor(i % 3600 / 60), c = i % 60;
  if (a > 0) {
    const u = (o) => String(o).padStart(2, "0");
    return `${u(c)}:${u(a)}`;
  }
  let s = "";
  return l > 0 && (s += `${l}h`), (l > 0 || d > 0) && (s += `${d}m`), s += `${c}s`, s;
}
function dn(e, t, n, r, i, a) {
  const l = e * t, d = i / l, c = (n - r) / (i / e), s = n - c * d, u = a / d, o = le(i, d, u), v = Math.max(0, Math.min(s, o));
  return { newZoom: l, newScroll: v };
}
const q = 30, mr = 240, bt = 16, ut = 36, $i = 40, $e = 32, ve = 4, St = 6, wt = 0.16, fn = 8, mn = 250, pr = 28, xt = 20, pn = 92, gn = 8, Tt = 1.5, gr = 0.01, hn = 20, ce = 1;
function Xe(e, t, n) {
  const r = e / t, i = r > 0 ? n / r : 0;
  return { visibleDuration: r, pps: i, maxScroll: le(e, r, i) };
}
function hr() {
  return Bn((e, t) => ({
    // Media metadata
    duration: 0,
    frameRate: 30,
    // Playback state
    currentTime: 0,
    isPlaying: !1,
    // Zoom/scroll state
    zoomLevel: 1,
    scrollPosition: 0,
    containerWidth: 0,
    // Tracks
    tracks: [],
    // Snap indicator
    snapIndicatorTime: null,
    // Drag guard
    draggingTrackId: null,
    // Actions
    setMetadata(n, r = 30) {
      e({
        duration: n,
        frameRate: r,
        currentTime: 0,
        isPlaying: !1,
        zoomLevel: 1,
        scrollPosition: 0
      });
    },
    setDuration(n) {
      const { zoomLevel: r, scrollPosition: i, containerWidth: a } = t(), { maxScroll: l } = Xe(n, r, a);
      e({
        duration: n,
        scrollPosition: Math.min(i, l)
      });
    },
    setCurrentTime(n) {
      const { duration: r, currentTime: i, isPlaying: a, zoomLevel: l, scrollPosition: d } = t(), c = Math.max(0, Math.min(n, r));
      if (i !== c) {
        if (a) {
          const s = r / l;
          if (c < d) {
            e({ currentTime: c, scrollPosition: c });
            return;
          } else if (c > d + s) {
            e({ currentTime: c, scrollPosition: c - s * 0.9 });
            return;
          }
        }
        e({ currentTime: c });
      }
    },
    setPlaying(n) {
      t().isPlaying !== n && e({ isPlaying: n });
    },
    setZoomLevel(n) {
      const { duration: r, frameRate: i, scrollPosition: a, containerWidth: l } = t(), d = r * i / hn, c = Math.max(ce, Math.min(n, d)), { maxScroll: s } = Xe(r, c, l);
      e({
        zoomLevel: c,
        scrollPosition: Math.min(a, s)
      });
    },
    setScrollPosition(n) {
      const { duration: r, zoomLevel: i, containerWidth: a } = t(), { maxScroll: l } = Xe(r, i, a);
      e({ scrollPosition: Math.max(0, Math.min(n, l)) });
    },
    setContainerWidth(n) {
      e({ containerWidth: n });
    },
    setTrackStartTime(n, r) {
      const i = t().tracks.map((a) => a.id === n ? { ...a, startTime: r } : a);
      e({ tracks: i });
    },
    setTrackTrim(n, r) {
      const i = t().tracks.map((a) => a.id === n ? { ...a, ...r } : a);
      e({ tracks: i });
    },
    setTracks(n) {
      const { draggingTrackId: r } = t();
      if (r != null) {
        const i = t().tracks.find((a) => a.id === r);
        i && (n = n.map(
          (a) => a.id === r ? {
            ...a,
            startTime: i.startTime,
            duration: i.duration,
            trimStart: i.trimStart,
            trimEnd: i.trimEnd
          } : a
        ));
      }
      e({ tracks: n });
    },
    setSnapIndicatorTime(n) {
      e({ snapIndicatorTime: n });
    },
    setDraggingTrackId(n) {
      e({ draggingTrackId: n });
    }
  }));
}
const xe = (e) => e.duration / e.zoomLevel, Z = (e) => {
  const t = e.duration / e.zoomLevel;
  return t > 0 ? e.containerWidth / t : 0;
}, vn = (e) => e.duration * e.frameRate / hn, yn = at(null);
function K() {
  const e = ct(yn);
  if (!e)
    throw new Error("useTimelineContext must be used within a <TimelineProvider>");
  return e;
}
function C(e) {
  const { store: t } = K();
  return Vn(t, e);
}
function Xi({
  children: e,
  duration: t,
  frameRate: n = 30,
  currentTime: r,
  isPlaying: i,
  onSeek: a,
  onPlayingChange: l,
  tracks: d,
  selectedTrackId: c,
  onTrackLockToggle: s,
  onTrackMuteToggle: u,
  onTrackVisibilityToggle: o,
  onTrackStartTimeChange: v,
  onTrackTrimChange: p,
  onTrackSelect: f,
  onTrackReorder: g
}) {
  const h = Je(() => hr(), []), y = R(!1);
  B(() => {
    if (!t || !Number.isFinite(t)) return;
    const w = h.getState();
    w.duration === t && w.frameRate === n || (y.current = !0, w.setMetadata(t, n), y.current = !1);
  }, [h, t, n]);
  const x = R(r), L = R(i);
  x.current = r, L.current = i, B(() => {
    let w;
    function T() {
      const S = x.current;
      if (S != null) {
        const { currentTime: A, duration: k } = h.getState(), D = Math.max(0, Math.min(S, k));
        A !== D && h.getState().setCurrentTime(S);
      }
      const E = L.current;
      E != null && h.getState().isPlaying !== E && (y.current = !0, h.getState().setPlaying(E), y.current = !1), w = requestAnimationFrame(T);
    }
    return w = requestAnimationFrame(T), () => cancelAnimationFrame(w);
  }, [h]), B(() => {
    let w = h.getState().isPlaying;
    return h.subscribe((T) => {
      T.isPlaying !== w && (w = T.isPlaying, y.current || l(T.isPlaying));
    });
  }, [h, l]), B(() => {
    d && h.getState().setTracks(d);
  }, [d, h]);
  const b = c ?? null, P = Je(
    () => ({
      store: h,
      onSeek: a,
      onTrackLockToggle: s,
      onTrackMuteToggle: u,
      onTrackVisibilityToggle: o,
      onTrackStartTimeChange: v,
      onTrackTrimChange: p,
      onTrackSelect: f,
      onTrackReorder: g,
      selectedTrackId: b
    }),
    [
      h,
      a,
      s,
      u,
      o,
      v,
      p,
      f,
      g,
      b
    ]
  );
  return /* @__PURE__ */ m(nr, { initiallyActiveScopes: [un], children: /* @__PURE__ */ m(yn.Provider, { value: P, children: e }) });
}
function vr({ togglePlay: e, stepFrame: t }) {
  const n = C((f) => f.isPlaying), r = C((f) => f.setPlaying), i = C((f) => f.setCurrentTime), a = C((f) => f.tracks.length > 0), { store: l, onSeek: d, selectedTrackId: c, onTrackStartTimeChange: s } = K(), u = O(() => {
    n && r(!1);
  }, [n, r]), o = O(() => {
    a && (u(), i(0), d(0));
  }, [u, i, a, d]), v = O(() => {
    if (!a) return;
    u();
    const { duration: f } = l.getState();
    i(f), d(f);
  }, [u, i, a, l, d]), p = { enableOnFormTags: !1, scopes: [un] };
  U(
    "space",
    (f) => {
      f.preventDefault(), e();
    },
    p
  ), U(
    "meta+left, ctrl+left",
    (f) => {
      f.preventDefault(), t(-1);
    },
    p
  ), U(
    "meta+right, ctrl+right",
    (f) => {
      f.preventDefault(), t(1);
    },
    p
  ), U(
    "meta+shift+left, ctrl+shift+left",
    (f) => {
      f.preventDefault(), t(-10);
    },
    p
  ), U(
    "meta+shift+right, ctrl+shift+right",
    (f) => {
      f.preventDefault(), t(10);
    },
    p
  ), U(
    "meta+shift+alt+left, ctrl+shift+alt+left",
    (f) => {
      f.preventDefault(), o();
    },
    p
  ), U(
    "meta+shift+alt+right, ctrl+shift+alt+right",
    (f) => {
      f.preventDefault(), v();
    },
    p
  ), U(
    "BracketLeft",
    () => {
      if (c == null) return;
      const { currentTime: f } = l.getState();
      u(), s(c, f, !1);
    },
    p
  ), U(
    "BracketRight",
    () => {
      if (c == null) return;
      const { currentTime: f, tracks: g } = l.getState(), h = g.find((y) => y.id === c);
      h && (u(), s(c, f - h.duration, !1));
    },
    p
  );
}
const yr = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M5.27734 2.44019C5.45049 2.44385 5.62082 2.48223 5.77832 2.55151L5.93066 2.63062L5.93262 2.63159L19.4375 10.8914C19.6282 11.0068 19.7861 11.1699 19.8955 11.364C20.0049 11.5581 20.0624 11.777 20.0625 11.9998C20.0625 12.2226 20.0049 12.4423 19.8955 12.6365C19.7865 12.8298 19.629 12.9909 19.4395 13.1062L5.93262 21.3679L5.93066 21.3689C5.7334 21.4886 5.50804 21.5544 5.27734 21.5593C5.04685 21.5642 4.81917 21.5084 4.61719 21.3972C4.46562 21.3138 4.33197 21.2014 4.22461 21.0671L4.12598 20.9255C4.00679 20.728 3.94178 20.5019 3.9375 20.2712V3.72827L3.95215 3.5564C3.97784 3.38663 4.03674 3.22294 4.12598 3.07495C4.24522 2.8774 4.41505 2.71457 4.61719 2.60327C4.81921 2.49208 5.04679 2.43536 5.27734 2.44019Z",
      fill: "currentColor"
    }
  )
] }), br = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m("g", { clipPath: "url(#clip0_822_591)", children: /* @__PURE__ */ m(
    "path",
    {
      d: "M9 3.96533C9.72479 3.96533 10.3124 4.55307 10.3125 5.27783V20.2778C10.3125 21.0027 9.72487 21.5903 9 21.5903H5.25C4.52513 21.5903 3.9375 21.0027 3.9375 20.2778V5.27783C3.93763 4.55307 4.52521 3.96533 5.25 3.96533H9ZM18.75 3.96533C19.4748 3.96533 20.0624 4.55307 20.0625 5.27783V20.2778C20.0625 21.0027 19.4749 21.5903 18.75 21.5903H15C14.2751 21.5903 13.6875 21.0027 13.6875 20.2778V5.27783C13.6876 4.55307 14.2752 3.96533 15 3.96533H18.75Z",
      fill: "currentColor"
    }
  ) }),
  /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", { id: "clip0_822_591", children: /* @__PURE__ */ m("rect", { width: "24", height: "24", fill: "white", transform: "translate(0 0.777832)" }) }) })
] }), Lt = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M6 6.02246V18.0225",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M9 6.75811V17.2862C9.00114 17.4188 9.0378 17.5486 9.10616 17.6622C9.17451 17.7758 9.27206 17.869 9.38865 17.9321C9.50524 17.9951 9.63661 18.0258 9.76909 18.0209C9.90156 18.016 10.0303 17.9756 10.1419 17.904L18.4097 12.64C18.5139 12.574 18.5997 12.4828 18.6591 12.3748C18.7186 12.2668 18.7497 12.1455 18.7497 12.0222C18.7497 11.8989 18.7186 11.7776 18.6591 11.6696C18.5997 11.5615 18.5139 11.4703 18.4097 11.4044L10.1419 6.1403C10.0303 6.06873 9.90156 6.02839 9.76909 6.02346C9.63661 6.01854 9.50524 6.04921 9.38865 6.11229C9.27206 6.17538 9.17451 6.26856 9.10616 6.38214C9.0378 6.49572 9.00114 6.62555 9 6.75811Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] });
function ie({ style: e, component: t, ...n }) {
  switch (t) {
    case "span":
      return /* @__PURE__ */ m("span", { style: { display: "flex", ...e }, ...n });
    case "button":
      return /* @__PURE__ */ m("button", { style: { display: "flex", ...e }, ...n });
    default:
      return /* @__PURE__ */ m("div", { style: { display: "flex", ...e }, ...n });
  }
}
function Sr({ style: e, ...t }) {
  return /* @__PURE__ */ m(ie, { style: { flexDirection: "column", ...e }, ...t });
}
function wr({ style: e, ...t }) {
  return /* @__PURE__ */ m(ie, { style: { justifyContent: "center", ...e }, ...t });
}
function J({ style: e, ...t }) {
  return /* @__PURE__ */ m(ie, { style: { alignItems: "center", ...e }, ...t });
}
function ue({ style: e, ...t }) {
  return /* @__PURE__ */ m(wr, { style: { alignItems: "center", ...e }, ...t });
}
const X = "var(--Black92)", xr = "var(--Black40_T)", de = "var(--White100)", be = "var(--White80_T)", Te = "var(--White64_T)", fe = "var(--White40_T)", Tr = "var(--White16_T)", N = "var(--White08_T)", Lr = "var(--White04_T)", bn = "var(--Yellow100)", Cr = "var(--Yellow64)", Er = "#F1A0FA", kr = "#EF9092", Pr = "#4452F2";
function se({ children: e, onClick: t, size: n = 24, disabled: r, ariaLabel: i, stopPropagation: a }) {
  return /* @__PURE__ */ m(
    ue,
    {
      component: "button",
      className: "icon-btn",
      style: {
        width: n,
        height: n,
        color: r ? fe : be,
        borderRadius: 4
      },
      disabled: r,
      "aria-label": i,
      onClick: (c) => {
        a && c.stopPropagation(), t();
      },
      onMouseDown: (c) => {
        a && c.stopPropagation();
      },
      children: e
    }
  );
}
function Mr({ options: e, value: t, onChange: n, size: r = 24 }) {
  const [i, a] = ee(null);
  return /* @__PURE__ */ m(en, { children: e.map((l, d) => {
    const c = l.value === t, s = i === d;
    let u = "transparent", o = be;
    return c && s ? (u = Cr, o = X) : c ? (u = bn, o = X) : s && (u = N, o = de), /* @__PURE__ */ m(
      ue,
      {
        component: "button",
        style: {
          width: r,
          height: r,
          padding: 0,
          borderRadius: 4,
          background: u,
          color: o
        },
        "aria-label": l.ariaLabel,
        onClick: () => n(l.value),
        onMouseEnter: () => a(d),
        onMouseLeave: () => a(null),
        children: l.icon
      },
      d
    );
  }) });
}
const Dr = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M12.7459 12.7421L20.4662 10.5859C20.6175 10.5395 20.7503 10.4465 20.8455 10.3201C20.9407 10.1936 20.9935 10.0403 20.9963 9.8821C20.9992 9.72386 20.9518 9.56878 20.8612 9.43907C20.7705 9.30935 20.6411 9.21165 20.4915 9.15994L3.9915 3.03994C3.85914 2.99493 3.71682 2.9878 3.58063 3.01937C3.44443 3.05095 3.31977 3.11996 3.22072 3.21863C3.12166 3.31729 3.05216 3.44168 3.02005 3.57775C2.98794 3.71382 2.9945 3.85616 3.039 3.98869L9.159 20.4887C9.2107 20.6383 9.30841 20.7677 9.43812 20.8584C9.56783 20.949 9.72291 20.9964 9.88115 20.9935C10.0394 20.9907 10.1927 20.9379 10.3191 20.8427C10.4455 20.7475 10.5386 20.6147 10.5849 20.4634L12.7459 12.7421Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Or = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M15.7501 7.125C15.7501 6.62772 15.9477 6.15081 16.2993 5.79917C16.6509 5.44754 17.1279 5.25 17.6251 5.25C18.1224 5.25 18.5993 5.44754 18.951 5.79917C19.3026 6.15081 19.5001 6.62772 19.5001 7.125V14.25C19.5001 15.2349 19.3061 16.2102 18.9292 17.1201C18.5523 18.0301 17.9999 18.8569 17.3034 19.5533C16.607 20.2497 15.7802 20.8022 14.8703 21.1791C13.9603 21.556 12.985 21.75 12.0001 21.75C7.85826 21.75 6.30482 19.755 3.25138 13.3125C3.00666 12.8821 2.94213 12.3723 3.07185 11.8945C3.20158 11.4167 3.51504 11.0096 3.94383 10.762C4.37262 10.5144 4.88193 10.4465 5.36061 10.5731C5.83928 10.6996 6.24848 11.0104 6.49888 11.4375L8.25013 14.25V5.625C8.25013 5.12772 8.44768 4.65081 8.79931 4.29917C9.15094 3.94754 9.62785 3.75 10.1251 3.75C10.6224 3.75 11.0993 3.94754 11.451 4.29917C11.8026 4.65081 12.0001 5.12772 12.0001 5.625",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M12 11.25V4.125C12 3.62772 12.1975 3.15081 12.5492 2.79917C12.9008 2.44754 13.3777 2.25 13.875 2.25C14.3723 2.25 14.8492 2.44754 15.2008 2.79917C15.5525 3.15081 15.75 3.62772 15.75 4.125V11.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Ct = () => /* @__PURE__ */ m("div", { style: { width: "1px", height: "24px", background: N } }), Sn = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M7.5 15.75H3C2.80109 15.75 2.61032 15.671 2.46967 15.5303C2.32902 15.3897 2.25 15.1989 2.25 15V9C2.25 8.80109 2.32902 8.61032 2.46967 8.46967C2.61032 8.32902 2.80109 8.25 3 8.25H7.5L14.25 3V21L7.5 15.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m("path", { d: "M7.5 8.25V15.75", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M18 10.0171C18.4825 10.5649 18.7487 11.2699 18.7487 11.9999C18.7487 12.7299 18.4825 13.4349 18 13.9827",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M20.7815 7.5C21.8884 8.73755 22.5003 10.3397 22.5003 12C22.5003 13.6603 21.8884 15.2624 20.7815 16.5",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Ar = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M22.1028 9.35278C22.3225 9.13311 22.678 9.13311 22.8977 9.35278C23.1171 9.57248 23.1173 9.92813 22.8977 10.1477L21.0452 12.0002L22.8977 13.8528L22.97 13.9407C23.114 14.159 23.0898 14.4556 22.8977 14.6477C22.7056 14.8398 22.409 14.864 22.1907 14.72L22.1028 14.6477L20.2502 12.7952L18.3977 14.6477C18.1781 14.8673 17.8225 14.8671 17.6028 14.6477C17.3831 14.428 17.3831 14.0725 17.6028 13.8528L19.4553 12.0002L17.6028 10.1477C17.3831 9.92804 17.3831 9.57245 17.6028 9.35278C17.8225 9.13311 18.178 9.13311 18.3977 9.35278L20.2502 11.2053L22.1028 9.35278Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M13.9043 2.55591C14.0739 2.42401 14.3041 2.40097 14.4971 2.49536C14.69 2.58978 14.8125 2.78547 14.8125 3.00024V21.0002C14.8124 21.215 14.69 21.4107 14.4971 21.5051C14.3041 21.5995 14.0739 21.5764 13.9043 21.4446L7.30664 16.3127H3C2.65194 16.3127 2.3184 16.1741 2.07227 15.928C1.82616 15.6819 1.68754 15.3483 1.6875 15.0002V9.00024C1.6875 8.65218 1.82617 8.31864 2.07227 8.07251C2.31841 7.82637 2.6519 7.68774 3 7.68774H7.30664L13.9043 2.55591ZM8.06152 8.52661V15.4729L13.6875 19.8489V4.15063L8.06152 8.52661ZM3 8.81274C2.95027 8.81274 2.90235 8.83227 2.86719 8.86743C2.83207 8.90259 2.8125 8.95055 2.8125 9.00024V15.0002L2.82715 15.0715C2.83648 15.0941 2.84957 15.1154 2.86719 15.1331C2.90234 15.1682 2.9503 15.1877 3 15.1877H6.93652V8.81274H3Z",
      fill: "currentColor"
    }
  )
] }), wn = ({
  onToggle: e,
  muted: t,
  size: n = "large",
  disabled: r
}) => {
  const i = n === "medium" ? 20 : 24, a = n === "medium" ? 14 : 18;
  return /* @__PURE__ */ m(se, { size: i, disabled: r, onClick: e, stopPropagation: !0, children: t ? /* @__PURE__ */ m(Ar, { width: a, height: a }) : /* @__PURE__ */ m(Sn, { width: a, height: a }) });
}, Ir = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m("path", { d: "M9.75 4.5L6 8.25L2.25 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })
] });
function Rr({ text: e, children: t }) {
  return /* @__PURE__ */ m("span", { style: { fontSize: "0.875rem", fontWeight: 400 }, children: e ?? t });
}
function jr({ text: e, children: t }) {
  return /* @__PURE__ */ m("span", { style: { fontSize: "0.75rem", fontWeight: 500 }, children: e ?? t });
}
function Wr({ text: e, children: t }) {
  return /* @__PURE__ */ m("span", { style: { fontSize: "0.75rem", fontWeight: 400 }, children: e ?? t });
}
function Hr({ text: e, children: t }) {
  return /* @__PURE__ */ m("span", { style: { fontSize: "0.625rem", fontWeight: 400, fontFamily: "'DM Mono', monospace" }, children: e ?? t });
}
const Et = 1.1;
function Fr({ label: e, shortcut: t, action: n, onClose: r }) {
  return /* @__PURE__ */ m("div", { style: { padding: "0 4px" }, children: /* @__PURE__ */ M(
    "button",
    {
      className: "canvas-zoom-menu-item",
      style: {
        border: "none",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding: "4px 8px",
        borderRadius: 4,
        cursor: "pointer",
        color: de,
        fontSize: "0.75rem"
      },
      onClick: () => {
        n(), r();
      },
      children: [
        /* @__PURE__ */ m("span", { children: e }),
        /* @__PURE__ */ m("span", { style: { color: Te }, children: `⌘ ${t}` })
      ]
    }
  ) });
}
function zr({ canvasZoom: e, onCanvasZoomChanged: t, onZoomToFit: n }) {
  const [r, i] = ee(!1), a = R(null), l = R(null);
  B(() => {
    if (!r) return;
    const f = (h) => {
      var y, x;
      (y = l.current) != null && y.contains(h.target) || (x = a.current) != null && x.contains(h.target) || i(!1);
    }, g = (h) => {
      h.key === "Escape" && (h.stopPropagation(), i(!1));
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", g, !0), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", g, !0);
    };
  }, [r]);
  const d = O(() => t(e * Et), [t, e]), c = O(() => t(e / Et), [t, e]), s = O(() => t(1), [t]), u = O(() => i(!1), []), o = [
    { label: "Zoom in", shortcut: "+", action: d },
    { label: "Zoom out", shortcut: "−", action: c },
    { label: "Zoom to 100%", shortcut: "0", action: s },
    { label: "Zoom to fit", shortcut: "1", action: n }
  ], [v, p] = ee({ bottom: 0, right: 0 });
  return tn(() => {
    if (!r || !a.current) return;
    const f = a.current.getBoundingClientRect();
    p({ bottom: window.innerHeight - f.top + 4, right: window.innerWidth - f.right });
  }, [r]), /* @__PURE__ */ M(en, { children: [
    /* @__PURE__ */ M(
      "button",
      {
        ref: a,
        style: {
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
          justifyContent: "space-between",
          padding: "4px 8px",
          borderRadius: 4,
          width: "78px",
          cursor: "pointer",
          color: de,
          background: r ? N : "transparent",
          marginLeft: 8
        },
        onClick: (f) => {
          f.stopPropagation(), i((g) => !g);
        },
        onMouseDown: (f) => f.stopPropagation(),
        children: [
          /* @__PURE__ */ m(jr, { text: `${Math.max(1, Math.trunc(e * 100))}%` }),
          /* @__PURE__ */ m(Ir, { style: { transform: r ? "rotate(180deg)" : void 0 } })
        ]
      }
    ),
    r && Kn(
      /* @__PURE__ */ m(
        "div",
        {
          ref: l,
          style: {
            position: "fixed",
            bottom: v.bottom,
            right: v.right,
            width: 180,
            background: X,
            border: `1px solid ${Lr}`,
            borderRadius: 8,
            padding: "4px 0",
            zIndex: 1e4
          },
          children: o.map((f) => /* @__PURE__ */ m(Fr, { ...f, onClose: u }, f.label))
        }
      ),
      document.body
    )
  ] });
}
function Nr(e, t) {
  return Math.round(Math.max(0, e) * t);
}
function Zi(e, t) {
  return Math.max(0, e) / t;
}
function Oe(e, t) {
  const n = Nr(e, t), r = n % t, i = Math.floor(n / t), a = Math.floor(i / 60), l = i % 60;
  return { minutes: a, seconds: l, frames: r };
}
function kt(e, t) {
  const n = e.minutes * 60 + e.seconds + e.frames / t;
  return Math.round(n * t) / t;
}
function Pt(e, t, n) {
  switch (e) {
    case "minutes":
      return Math.max(0, t);
    case "seconds":
      return Math.max(0, Math.min(59, t));
    case "frames":
      return Math.max(0, Math.min(n - 1, t));
  }
}
const Ze = ["minutes", "seconds", "frames"];
function Br(e) {
  return String(Math.floor(e)).padStart(2, "0");
}
function Mt(e, t) {
  return Math.max(0, Math.min(e, t));
}
function Vr() {
  const e = C((s) => s.currentTime), t = C((s) => s.frameRate), n = C((s) => s.duration), r = C((s) => s.setCurrentTime), i = C((s) => s.isPlaying), a = C((s) => s.setPlaying), { onSeek: l } = K(), d = O(
    (s) => {
      r(s), l(s);
    },
    [r, l]
  ), c = O(() => {
    i && a(!1);
  }, [i, a]);
  return /* @__PURE__ */ m(
    Kr,
    {
      value: e,
      duration: n,
      frameRate: t,
      onChange: d,
      onEditingStart: c
    }
  );
}
function Kr({ value: e, duration: t, frameRate: n, onChange: r, onEditingStart: i, style: a }) {
  const [l, d] = ee(!1), [c, s] = ee(() => Oe(e, n)), u = R(null), o = R([null, null, null]), v = R(!1), p = Oe(e, n), f = l ? c : p, g = O(
    (w) => {
      const T = kt(w, n), S = Mt(T, t);
      r(S);
    },
    [t, n, r]
  ), h = O(() => {
    const w = kt(c, n), T = Mt(w, t);
    r(T), d(!1);
  }, [t, c, n, r]), y = O(() => {
    s(Oe(e, n)), d(!1);
  }, [e, n]), x = O(() => {
    l || (s(Oe(e, n)), d(!0), i == null || i());
  }, [n, l, i, e]), L = O(
    (w) => {
      var S;
      const T = w.relatedTarget;
      if (!((S = u.current) != null && S.contains(T))) {
        if (v.current) {
          v.current = !1;
          return;
        }
        l && h();
      }
    },
    [l, h]
  ), b = O(
    (w, T) => {
      const S = parseInt(T, 10);
      if (isNaN(S)) return;
      const E = Pt(w, S, n);
      s((A) => ({ ...A, [w]: E }));
    },
    [n]
  ), P = (w, T) => {
    var A, k;
    const S = Ze[w], E = T.currentTarget;
    switch (T.key) {
      case "ArrowUp":
      case "ArrowDown": {
        T.preventDefault();
        const D = T.key === "ArrowUp" ? 1 : -1, I = Pt(S, c[S] + D, n), H = { ...c, [S]: I };
        s(H), g(H);
        break;
      }
      case "ArrowLeft": {
        E.selectionStart === 0 && E.selectionEnd === 0 && w > 0 && (T.preventDefault(), (A = o.current[w - 1]) == null || A.focus());
        break;
      }
      case "ArrowRight": {
        const D = E.value.length;
        E.selectionStart === D && E.selectionEnd === D && w < Ze.length - 1 && (T.preventDefault(), (k = o.current[w + 1]) == null || k.focus());
        break;
      }
      case "Enter":
        T.preventDefault(), h(), v.current = !0, E.blur();
        break;
      case "Escape":
        T.preventDefault(), y(), v.current = !0, E.blur();
        break;
    }
  };
  return B(() => {
    const w = o.current, T = (S) => S.target.select();
    return w.forEach((S) => S == null ? void 0 : S.addEventListener("focus", T)), () => w.forEach((S) => S == null ? void 0 : S.removeEventListener("focus", T));
  }, []), /* @__PURE__ */ m(
    "div",
    {
      className: "timecode-input",
      ref: u,
      onBlur: L,
      style: {
        display: "inline-flex",
        alignItems: "center",
        height: 24,
        fontSize: "0.75rem",
        border: `1px solid ${Tr}`,
        borderRadius: 4,
        padding: "0 8px",
        boxSizing: "border-box",
        transition: "border-color 0.15s",
        ...a
      },
      children: Ze.map((w, T) => /* @__PURE__ */ M(J, { children: [
        T > 0 && /* @__PURE__ */ m(
          "span",
          {
            style: { position: "relative", top: "-1px", color: Te, pointerEvents: "none", userSelect: "none" },
            children: ":"
          }
        ),
        /* @__PURE__ */ m(
          "input",
          {
            ref: (S) => {
              o.current[T] = S;
            },
            className: "timecode-segment",
            type: "text",
            inputMode: "numeric",
            value: Br(f[w]),
            onFocus: x,
            onMouseDown: (S) => {
              document.activeElement === S.currentTarget && S.preventDefault();
            },
            onSelect: (S) => {
              const E = S.currentTarget, A = (E.selectionEnd ?? 0) - (E.selectionStart ?? 0);
              A > 0 && A < E.value.length && E.select();
            },
            onChange: (S) => b(w, S.target.value),
            onKeyDown: (S) => P(T, S),
            "aria-label": w,
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            "data-form-type": "other",
            spellCheck: !1,
            style: {
              width: "2ch",
              background: "transparent",
              border: "none",
              outline: "none",
              color: Te,
              textAlign: "center",
              padding: "1px 0",
              borderRadius: 2,
              caretColor: "transparent",
              font: "inherit"
            }
          }
        )
      ] }, w))
    }
  );
}
function Ui({
  isMuted: e = !1,
  onToggleMute: t,
  canvasMode: n,
  onCanvasModeChange: r,
  canvasZoom: i,
  onCanvasZoomChanged: a,
  onZoomToFit: l
}) {
  const d = C((y) => y.isPlaying), c = C((y) => y.currentTime <= 0), s = C((y) => y.currentTime >= y.duration), u = C((y) => y.setPlaying), o = C((y) => y.setCurrentTime), v = C((y) => y.tracks.length > 0), { store: p, onSeek: f } = K(), g = O(() => {
    v && u(!d);
  }, [d, u, v]), h = O(
    (y) => {
      if (!v) return;
      d && u(!1);
      const { currentTime: x, duration: L, frameRate: b } = p.getState(), P = Math.round(x * b), T = Math.max(0, Math.min(P + y, Math.round(L * b))) / b;
      o(T), f(T);
    },
    [d, u, o, v, p, f]
  );
  return vr({ togglePlay: g, stepFrame: h }), /* @__PURE__ */ M(
    J,
    {
      className: "timeline-playback-controls",
      style: {
        height: "40px",
        padding: "0 8px",
        background: X,
        fontFamily: "'DM Sans', sans-serif"
      },
      children: [
        /* @__PURE__ */ m("div", { style: { flex: 1 } }),
        /* @__PURE__ */ M(ue, { style: { gap: 8 }, children: [
          /* @__PURE__ */ m(se, { onClick: () => h(-1), disabled: !v || c, ariaLabel: "Step back one frame", children: /* @__PURE__ */ m(Lt, { style: { transform: "scaleX(-1)" } }) }),
          /* @__PURE__ */ m(se, { onClick: g, disabled: !v, ariaLabel: d ? "Pause" : "Play", children: d ? /* @__PURE__ */ m(br, { width: 20, height: 20 }) : /* @__PURE__ */ m(yr, { width: 20, height: 20 }) }),
          /* @__PURE__ */ m(se, { onClick: () => h(1), disabled: !v || s, ariaLabel: "Step forward one frame", children: /* @__PURE__ */ m(Lt, {}) }),
          /* @__PURE__ */ m(Vr, {}),
          /* @__PURE__ */ m(Ct, {}),
          t && /* @__PURE__ */ m(wn, { onToggle: t, muted: e, disabled: !v })
        ] }),
        /* @__PURE__ */ M(J, { style: { flex: 1, justifyContent: "flex-end" }, children: [
          /* @__PURE__ */ m(J, { style: { gap: "4px", marginRight: "8px" }, children: /* @__PURE__ */ m(
            Mr,
            {
              options: [
                { value: "select", icon: /* @__PURE__ */ m(Dr, { width: 20, height: 20 }), ariaLabel: "Select tool" },
                { value: "pan", icon: /* @__PURE__ */ m(Or, { width: 20, height: 20 }), ariaLabel: "Pan tool" }
              ],
              value: n,
              onChange: r,
              size: 24
            }
          ) }),
          /* @__PURE__ */ m(Ct, {}),
          /* @__PURE__ */ m(zr, { canvasZoom: i, onCanvasZoomChanged: a, onZoomToFit: l })
        ] })
      ]
    }
  );
}
function $r(e) {
  if (Array.isArray(e)) return e;
}
function Xr(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, l, d = [], c = !0, s = !1;
    try {
      if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (d.push(r.value), d.length !== t); c = !0) ;
    } catch (u) {
      s = !0, i = u;
    } finally {
      try {
        if (!c && n.return != null && (l = n.return(), Object(l) !== l)) return;
      } finally {
        if (s) throw i;
      }
    }
    return d;
  }
}
function et(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function xn(e, t) {
  if (e) {
    if (typeof e == "string") return et(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? et(e, t) : void 0;
  }
}
function Zr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tn(e, t) {
  return $r(e) || Xr(e, t) || xn(e, t) || Zr();
}
var Ue = {}, ye = {}, Dt;
function Ln() {
  if (Dt) return ye;
  Dt = 1, Object.defineProperty(ye, "__esModule", { value: !0 }), ye.bind = void 0;
  function e(t, n) {
    var r = n.type, i = n.listener, a = n.options;
    return t.addEventListener(r, i, a), function() {
      t.removeEventListener(r, i, a);
    };
  }
  return ye.bind = e, ye;
}
var oe = {}, Ot;
function Ur() {
  if (Ot) return oe;
  Ot = 1;
  var e = oe && oe.__assign || function() {
    return e = Object.assign || function(a) {
      for (var l, d = 1, c = arguments.length; d < c; d++) {
        l = arguments[d];
        for (var s in l) Object.prototype.hasOwnProperty.call(l, s) && (a[s] = l[s]);
      }
      return a;
    }, e.apply(this, arguments);
  };
  Object.defineProperty(oe, "__esModule", { value: !0 }), oe.bindAll = void 0;
  var t = /* @__PURE__ */ Ln();
  function n(a) {
    if (!(typeof a > "u"))
      return typeof a == "boolean" ? {
        capture: a
      } : a;
  }
  function r(a, l) {
    if (l == null)
      return a;
    var d = e(e({}, a), { options: e(e({}, n(l)), n(a.options)) });
    return d;
  }
  function i(a, l, d) {
    var c = l.map(function(s) {
      var u = r(s, d);
      return (0, t.bind)(a, u);
    });
    return function() {
      c.forEach(function(u) {
        return u();
      });
    };
  }
  return oe.bindAll = i, oe;
}
var At;
function Yr() {
  return At || (At = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.bindAll = e.bind = void 0;
    var t = /* @__PURE__ */ Ln();
    Object.defineProperty(e, "bind", { enumerable: !0, get: function() {
      return t.bind;
    } });
    var n = /* @__PURE__ */ Ur();
    Object.defineProperty(e, "bindAll", { enumerable: !0, get: function() {
      return n.bindAll;
    } });
  })(Ue)), Ue;
}
var me = /* @__PURE__ */ Yr(), Cn = "data-pdnd-honey-pot";
function En(e) {
  return e instanceof Element && e.hasAttribute(Cn);
}
function dt(e) {
  var t = document.elementsFromPoint(e.x, e.y), n = Tn(t, 2), r = n[0], i = n[1];
  return r ? En(r) ? i ?? null : r : null;
}
function Le(e) {
  "@babel/helpers - typeof";
  return Le = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Le(e);
}
function _r(e, t) {
  if (Le(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Le(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Gr(e) {
  var t = _r(e, "string");
  return Le(t) == "symbol" ? t : t + "";
}
function _(e, t, n) {
  return (t = Gr(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var qr = 2147483647;
function It(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? It(Object(n), !0).forEach(function(r) {
      _(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : It(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ce = 2, jt = Ce / 2;
function Qr(e) {
  return {
    x: Math.floor(e.x),
    y: Math.floor(e.y)
  };
}
function Jr(e) {
  return {
    x: e.x - jt,
    y: e.y - jt
  };
}
function eo(e) {
  return {
    x: Math.max(e.x, 0),
    y: Math.max(e.y, 0)
  };
}
function to(e) {
  return {
    x: Math.min(e.x, window.innerWidth - Ce),
    y: Math.min(e.y, window.innerHeight - Ce)
  };
}
function Wt(e) {
  var t = e.client, n = to(eo(Jr(Qr(t))));
  return DOMRect.fromRect({
    x: n.x,
    y: n.y,
    width: Ce,
    height: Ce
  });
}
function Ht(e) {
  var t = e.clientRect;
  return {
    left: "".concat(t.left, "px"),
    top: "".concat(t.top, "px"),
    width: "".concat(t.width, "px"),
    height: "".concat(t.height, "px")
  };
}
function no(e) {
  var t = e.client, n = e.clientRect;
  return (
    // is within horizontal bounds
    t.x >= n.x && t.x <= n.x + n.width && // is within vertical bounds
    t.y >= n.y && t.y <= n.y + n.height
  );
}
function ro(e) {
  var t = e.initial, n = document.createElement("div");
  n.setAttribute(Cn, "true");
  var r = Wt({
    client: t
  });
  Object.assign(n.style, Rt(Rt({
    // Setting a background color explicitly to avoid any inherited styles.
    // Looks like this could be `opacity: 0`, but worried that _might_
    // cause the element to be ignored on some platforms.
    // When debugging, set backgroundColor to something like "red".
    backgroundColor: "transparent",
    position: "fixed",
    // Being explicit to avoid inheriting styles
    padding: 0,
    margin: 0,
    boxSizing: "border-box"
  }, Ht({
    clientRect: r
  })), {}, {
    // We want this element to absorb pointer events,
    // it's kind of the whole point 😉
    pointerEvents: "auto",
    // Want to make sure the honey pot is top of everything else.
    // Don't need to worry about native drag previews, as they will
    // have been rendered (and removed) before the honey pot is rendered
    zIndex: qr
  })), document.body.appendChild(n);
  var i = me.bind(window, {
    type: "pointermove",
    listener: function(l) {
      var d = {
        x: l.clientX,
        y: l.clientY
      };
      r = Wt({
        client: d
      }), Object.assign(n.style, Ht({
        clientRect: r
      }));
    },
    // using capture so we are less likely to be impacted by event stopping
    options: {
      capture: !0
    }
  });
  return function(l) {
    var d = l.current;
    if (i(), no({
      client: d,
      clientRect: r
    })) {
      n.remove();
      return;
    }
    function c() {
      s(), n.remove();
    }
    var s = me.bindAll(window, [
      {
        type: "pointerdown",
        listener: c
      },
      {
        type: "pointermove",
        listener: c
      },
      {
        type: "focusin",
        listener: c
      },
      {
        type: "focusout",
        listener: c
      },
      // a 'pointerdown' should happen before 'dragstart', but just being super safe
      {
        type: "dragstart",
        listener: c
      },
      // if the user has dragged something out of the window
      // and then is dragging something back into the window
      // the first events we will see are "dragenter" (and then "dragover").
      // So if we see any of these we need to clear the post drag fix.
      {
        type: "dragenter",
        listener: c
      },
      {
        type: "dragover",
        listener: c
      }
      // Not adding a "wheel" event listener, as "wheel" by itself does not
      // resolve the bug.
    ], {
      // Using `capture` so less likely to be impacted by other code stopping events
      capture: !0
    });
  };
}
function oo() {
  var e = null;
  function t() {
    return e = null, me.bind(window, {
      type: "pointermove",
      listener: function(i) {
        e = {
          x: i.clientX,
          y: i.clientY
        };
      },
      // listening for pointer move in capture phase
      // so we are less likely to be impacted by events being stopped.
      options: {
        capture: !0
      }
    });
  }
  function n() {
    var r = null;
    return function(a) {
      var l = a.eventName, d = a.payload;
      if (l === "onDragStart") {
        var c = d.location.initial.input, s = e ?? {
          x: c.clientX,
          y: c.clientY
        };
        r = ro({
          initial: s
        });
      }
      if (l === "onDrop") {
        var u, o = d.location.current.input;
        (u = r) === null || u === void 0 || u({
          current: {
            x: o.clientX,
            y: o.clientY
          }
        }), r = null, e = null;
      }
    };
  }
  return {
    bindEvents: t,
    getOnPostDispatch: n
  };
}
function io(e) {
  if (Array.isArray(e)) return et(e);
}
function ao(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function co() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kn(e) {
  return io(e) || ao(e) || xn(e) || co();
}
function te(e) {
  var t = null;
  return function() {
    if (!t) {
      for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++)
        i[a] = arguments[a];
      var l = e.apply(this, i);
      t = {
        result: l
      };
    }
    return t.result;
  };
}
var so = te(function() {
  return process.env.NODE_ENV === "test" ? !1 : navigator.userAgent.includes("Firefox");
}), ft = te(function() {
  if (process.env.NODE_ENV === "test")
    return !1;
  var t = navigator, n = t.userAgent;
  return n.includes("AppleWebKit") && !n.includes("Chrome");
}), tt = {
  isLeavingWindow: Symbol("leaving"),
  isEnteringWindow: Symbol("entering")
};
function lo(e) {
  var t = e.dragLeave;
  return ft() ? t.hasOwnProperty(tt.isLeavingWindow) : !1;
}
(function() {
  if (typeof window > "u" || process.env.NODE_ENV === "test" || !ft())
    return;
  function t() {
    return {
      enterCount: 0,
      isOverWindow: !1
    };
  }
  var n = t();
  function r() {
    n = t();
  }
  me.bindAll(
    window,
    [{
      type: "dragstart",
      listener: function() {
        n.enterCount = 0, n.isOverWindow = !0;
      }
    }, {
      type: "drop",
      listener: r
    }, {
      type: "dragend",
      listener: r
    }, {
      type: "dragenter",
      listener: function(a) {
        !n.isOverWindow && n.enterCount === 0 && (a[tt.isEnteringWindow] = !0), n.isOverWindow = !0, n.enterCount++;
      }
    }, {
      type: "dragleave",
      listener: function(a) {
        n.enterCount--, n.isOverWindow && n.enterCount === 0 && (a[tt.isLeavingWindow] = !0, n.isOverWindow = !1);
      }
    }],
    // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
      capture: !0
    }
  );
})();
function uo(e) {
  return "nodeName" in e;
}
function fo(e) {
  return uo(e) && e.ownerDocument !== document;
}
function mo(e) {
  var t = e.dragLeave, n = t.type, r = t.relatedTarget;
  return n !== "dragleave" ? !1 : ft() ? lo({
    dragLeave: t
  }) : r == null ? !0 : so() ? fo(r) : r instanceof HTMLIFrameElement;
}
function po(e) {
  var t = e.onDragEnd;
  return [
    // ## Detecting drag ending for removed draggables
    //
    // If a draggable element is removed during a drag and the user drops:
    // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
    // 2. if not over a valid drop target (or cancelled): we get nothing
    // The "dragend" event will not fire on the source draggable if it has been
    // removed from the DOM.
    // So we need to figure out if a drag operation has finished by looking at other events
    // We can do this by looking at other events
    // ### First detection: "pointermove" events
    // 1. "pointermove" events cannot fire during a drag and drop operation
    // according to the spec. So if we get a "pointermove" it means that
    // the drag and drop operations has finished. So if we get a "pointermove"
    // we know that the drag is over
    // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
    // other pointer events. However, firefox will allow a few
    // pointer event to get through after a drag starts.
    // The most I've seen is 3
    {
      type: "pointermove",
      listener: /* @__PURE__ */ (function() {
        var n = 0;
        return function() {
          if (n < 20) {
            n++;
            return;
          }
          t();
        };
      })()
    },
    // ### Second detection: "pointerdown" events
    // If we receive this event then we know that a drag operation has finished
    // and potentially another one is about to start.
    // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
    {
      type: "pointerdown",
      listener: t
    }
  ];
}
function Se(e) {
  return {
    altKey: e.altKey,
    button: e.button,
    buttons: e.buttons,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    shiftKey: e.shiftKey,
    clientX: e.clientX,
    clientY: e.clientY,
    pageX: e.pageX,
    pageY: e.pageY
  };
}
var go = function(t) {
  var n = [], r = null, i = function() {
    for (var l = arguments.length, d = new Array(l), c = 0; c < l; c++)
      d[c] = arguments[c];
    n = d, !r && (r = requestAnimationFrame(function() {
      r = null, t.apply(void 0, n);
    }));
  };
  return i.cancel = function() {
    r && (cancelAnimationFrame(r), r = null);
  }, i;
}, Ye = go(function(e) {
  return e();
}), Ae = /* @__PURE__ */ (function() {
  var e = null;
  function t(r) {
    var i = requestAnimationFrame(function() {
      e = null, r();
    });
    e = {
      frameId: i,
      fn: r
    };
  }
  function n() {
    e && (cancelAnimationFrame(e.frameId), e.fn(), e = null);
  }
  return {
    schedule: t,
    flush: n
  };
})();
function ho(e) {
  var t = e.source, n = e.initial, r = e.dispatchEvent, i = {
    dropTargets: []
  };
  function a(d) {
    r(d), i = {
      dropTargets: d.payload.location.current.dropTargets
    };
  }
  var l = {
    start: function(c) {
      var s = c.nativeSetDragImage, u = {
        current: n,
        previous: i,
        initial: n
      };
      a({
        eventName: "onGenerateDragPreview",
        payload: {
          source: t,
          location: u,
          nativeSetDragImage: s
        }
      }), Ae.schedule(function() {
        a({
          eventName: "onDragStart",
          payload: {
            source: t,
            location: u
          }
        });
      });
    },
    dragUpdate: function(c) {
      var s = c.current;
      Ae.flush(), Ye.cancel(), a({
        eventName: "onDropTargetChange",
        payload: {
          source: t,
          location: {
            initial: n,
            previous: i,
            current: s
          }
        }
      });
    },
    drag: function(c) {
      var s = c.current;
      Ye(function() {
        Ae.flush();
        var u = {
          initial: n,
          previous: i,
          current: s
        };
        a({
          eventName: "onDrag",
          payload: {
            source: t,
            location: u
          }
        });
      });
    },
    drop: function(c) {
      var s = c.current, u = c.updatedSourcePayload;
      Ae.flush(), Ye.cancel(), a({
        eventName: "onDrop",
        payload: {
          source: u ?? t,
          location: {
            current: s,
            previous: i,
            initial: n
          }
        }
      });
    }
  };
  return l;
}
var nt = {
  isActive: !1
};
function Pn() {
  return !nt.isActive;
}
function vo(e) {
  return e.dataTransfer ? e.dataTransfer.setDragImage.bind(e.dataTransfer) : null;
}
function yo(e) {
  var t = e.current, n = e.next;
  if (t.length !== n.length)
    return !0;
  for (var r = 0; r < t.length; r++)
    if (t[r].element !== n[r].element)
      return !0;
  return !1;
}
function bo(e) {
  var t = e.event, n = e.dragType, r = e.getDropTargetsOver, i = e.dispatchEvent;
  if (!Pn())
    return;
  var a = So({
    event: t,
    dragType: n,
    getDropTargetsOver: r
  });
  nt.isActive = !0;
  var l = {
    current: a
  };
  _e({
    event: t,
    current: a.dropTargets
  });
  var d = ho({
    source: n.payload,
    dispatchEvent: i,
    initial: a
  });
  function c(p) {
    var f = yo({
      current: l.current.dropTargets,
      next: p.dropTargets
    });
    l.current = p, f && d.dragUpdate({
      current: l.current
    });
  }
  function s(p) {
    var f = Se(p), g = En(p.target) ? dt({
      x: f.clientX,
      y: f.clientY
    }) : p.target, h = r({
      target: g,
      input: f,
      source: n.payload,
      current: l.current.dropTargets
    });
    h.length && (p.preventDefault(), _e({
      event: p,
      current: h
    })), c({
      dropTargets: h,
      input: f
    });
  }
  function u() {
    l.current.dropTargets.length && c({
      dropTargets: [],
      input: l.current.input
    }), d.drop({
      current: l.current,
      updatedSourcePayload: null
    }), o();
  }
  function o() {
    nt.isActive = !1, v();
  }
  var v = me.bindAll(
    window,
    [{
      // 👋 Note: we are repurposing the `dragover` event as our `drag` event
      // this is because firefox does not publish pointer coordinates during
      // a `drag` event, but does for every other type of drag event
      // `dragover` fires on all elements that are being dragged over
      // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
      // 🦊😤
      type: "dragover",
      listener: function(f) {
        s(f), d.drag({
          current: l.current
        });
      }
    }, {
      type: "dragenter",
      listener: s
    }, {
      type: "dragleave",
      listener: function(f) {
        mo({
          dragLeave: f
        }) && (c({
          input: l.current.input,
          dropTargets: []
        }), n.startedFrom === "external" && u());
      }
    }, {
      // A "drop" can only happen if the browser allowed the drop
      type: "drop",
      listener: function(f) {
        if (l.current = {
          dropTargets: l.current.dropTargets,
          input: Se(f)
        }, !l.current.dropTargets.length) {
          u();
          return;
        }
        f.preventDefault(), _e({
          event: f,
          current: l.current.dropTargets
        }), d.drop({
          current: l.current,
          // When dropping something native, we need to extract the latest
          // `.items` from the "drop" event as it is now accessible
          updatedSourcePayload: n.type === "external" ? n.getDropPayload(f) : null
        }), o();
      }
    }, {
      // "dragend" fires when on the drag source (eg a draggable element)
      // when the drag is finished.
      // "dragend" will fire after "drop" (if there was a successful drop)
      // "dragend" does not fire if the draggable source has been removed during the drag
      // or for external drag sources (eg files)
      // This "dragend" listener will not fire if there was a successful drop
      // as we will have already removed the event listener
      type: "dragend",
      listener: function(f) {
        l.current = {
          dropTargets: l.current.dropTargets,
          input: Se(f)
        }, u();
      }
    }].concat(kn(po({
      onDragEnd: u
    }))),
    // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
      capture: !0
    }
  );
  d.start({
    nativeSetDragImage: vo(t)
  });
}
function _e(e) {
  var t, n = e.event, r = e.current, i = (t = r[0]) === null || t === void 0 ? void 0 : t.dropEffect;
  i != null && n.dataTransfer && (n.dataTransfer.dropEffect = i);
}
function So(e) {
  var t = e.event, n = e.dragType, r = e.getDropTargetsOver, i = Se(t);
  if (n.startedFrom === "external")
    return {
      input: i,
      dropTargets: []
    };
  var a = r({
    input: i,
    source: n.payload,
    target: t.target,
    current: []
  });
  return {
    input: i,
    dropTargets: a
  };
}
var Ft = {
  canStart: Pn,
  start: bo
}, rt = /* @__PURE__ */ new Map();
function wo(e) {
  var t = e.typeKey, n = e.mount, r = rt.get(t);
  if (r)
    return r.usageCount++, r;
  var i = {
    typeKey: t,
    unmount: n(),
    usageCount: 1
  };
  return rt.set(t, i), i;
}
function xo(e) {
  var t = wo(e);
  return function() {
    t.usageCount--, !(t.usageCount > 0) && (t.unmount(), rt.delete(e.typeKey));
  };
}
function We() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function() {
    t.forEach(function(i) {
      return i();
    });
  };
}
function Mn(e, t) {
  var n = t.attribute, r = t.value;
  return e.setAttribute(n, r), function() {
    return e.removeAttribute(n);
  };
}
function zt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function G(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zt(Object(n), !0).forEach(function(r) {
      _(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ge(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = To(e)) || t) {
      n && (e = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(s) {
        throw s;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, l = !0, d = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var s = n.next();
    return l = s.done, s;
  }, e: function(s) {
    d = !0, a = s;
  }, f: function() {
    try {
      l || n.return == null || n.return();
    } finally {
      if (d) throw a;
    }
  } };
}
function To(e, t) {
  if (e) {
    if (typeof e == "string") return Nt(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Nt(e, t) : void 0;
  }
}
function Nt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function qe(e) {
  return e.slice(0).reverse();
}
function Lo(e) {
  var t = e.typeKey, n = e.defaultDropEffect, r = /* @__PURE__ */ new WeakMap(), i = "data-drop-target-for-".concat(t), a = "[".concat(i, "]");
  function l(p) {
    return r.set(p.element, p), function() {
      return r.delete(p.element);
    };
  }
  function d(p) {
    if (process.env.NODE_ENV !== "production") {
      var f = r.get(p.element);
      f && console.warn("You have already registered a [".concat(t, "] dropTarget on the same element"), {
        existing: f,
        proposed: p
      }), p.element instanceof HTMLIFrameElement && console.warn(`
            We recommend not registering <iframe> elements as drop targets
            as it can result in some strange browser event ordering.
          `.replace(/\s{2,}/g, " ").trim());
    }
    var g = We(Mn(p.element, {
      attribute: i,
      value: "true"
    }), l(p));
    return te(g);
  }
  function c(p) {
    var f, g, h, y, x = p.source, L = p.target, b = p.input, P = p.result, w = P === void 0 ? [] : P;
    if (L == null)
      return w;
    if (!(L instanceof Element))
      return L instanceof Node ? c({
        source: x,
        target: L.parentElement,
        input: b,
        result: w
      }) : w;
    var T = L.closest(a);
    if (T == null)
      return w;
    var S = r.get(T);
    if (S == null)
      return w;
    var E = {
      input: b,
      source: x,
      element: S.element
    };
    if (S.canDrop && !S.canDrop(E))
      return c({
        source: x,
        target: S.element.parentElement,
        input: b,
        result: w
      });
    var A = (f = (g = S.getData) === null || g === void 0 ? void 0 : g.call(S, E)) !== null && f !== void 0 ? f : {}, k = (h = (y = S.getDropEffect) === null || y === void 0 ? void 0 : y.call(S, E)) !== null && h !== void 0 ? h : n, D = {
      data: A,
      element: S.element,
      dropEffect: k,
      // we are collecting _actual_ drop targets, so these are
      // being applied _not_ due to stickiness
      isActiveDueToStickiness: !1
    };
    return c({
      source: x,
      target: S.element.parentElement,
      input: b,
      // Using bubble ordering. Same ordering as `event.getPath()`
      result: [].concat(kn(w), [D])
    });
  }
  function s(p) {
    var f = p.eventName, g = p.payload, h = Ge(g.location.current.dropTargets), y;
    try {
      for (h.s(); !(y = h.n()).done; ) {
        var x, L = y.value, b = r.get(L.element), P = G(G({}, g), {}, {
          self: L
        });
        b == null || (x = b[f]) === null || x === void 0 || x.call(
          b,
          // I cannot seem to get the types right here.
          // TS doesn't seem to like that one event can need `nativeSetDragImage`
          // @ts-expect-error
          P
        );
      }
    } catch (w) {
      h.e(w);
    } finally {
      h.f();
    }
  }
  var u = {
    onGenerateDragPreview: s,
    onDrag: s,
    onDragStart: s,
    onDrop: s,
    onDropTargetChange: function(f) {
      var g = f.payload, h = new Set(g.location.current.dropTargets.map(function(V) {
        return V.element;
      })), y = /* @__PURE__ */ new Set(), x = Ge(g.location.previous.dropTargets), L;
      try {
        for (x.s(); !(L = x.n()).done; ) {
          var b, P = L.value;
          y.add(P.element);
          var w = r.get(P.element), T = h.has(P.element), S = G(G({}, g), {}, {
            self: P
          });
          if (w == null || (b = w.onDropTargetChange) === null || b === void 0 || b.call(w, S), !T) {
            var E;
            w == null || (E = w.onDragLeave) === null || E === void 0 || E.call(w, S);
          }
        }
      } catch (V) {
        x.e(V);
      } finally {
        x.f();
      }
      var A = Ge(g.location.current.dropTargets), k;
      try {
        for (A.s(); !(k = A.n()).done; ) {
          var D, I, H = k.value;
          if (!y.has(H.element)) {
            var z = G(G({}, g), {}, {
              self: H
            }), j = r.get(H.element);
            j == null || (D = j.onDropTargetChange) === null || D === void 0 || D.call(j, z), j == null || (I = j.onDragEnter) === null || I === void 0 || I.call(j, z);
          }
        }
      } catch (V) {
        A.e(V);
      } finally {
        A.f();
      }
    }
  };
  function o(p) {
    u[p.eventName](p);
  }
  function v(p) {
    var f = p.source, g = p.target, h = p.input, y = p.current, x = c({
      source: f,
      target: g,
      input: h
    });
    if (x.length >= y.length)
      return x;
    for (var L = qe(y), b = qe(x), P = [], w = 0; w < L.length; w++) {
      var T, S = L[w], E = b[w];
      if (E != null) {
        P.push(E);
        continue;
      }
      var A = P[w - 1], k = L[w - 1];
      if ((A == null ? void 0 : A.element) !== (k == null ? void 0 : k.element))
        break;
      var D = r.get(S.element);
      if (!D)
        break;
      var I = {
        input: h,
        source: f,
        element: D.element
      };
      if (D.canDrop && !D.canDrop(I) || !((T = D.getIsSticky) !== null && T !== void 0 && T.call(D, I)))
        break;
      P.push(G(G({}, S), {}, {
        // making it clear to consumers this drop target is active due to stickiness
        isActiveDueToStickiness: !0
      }));
    }
    return qe(P);
  }
  return {
    dropTargetForConsumers: d,
    getIsOver: v,
    dispatchEvent: o
  };
}
function Co(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Eo(e)) || t) {
      n && (e = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(s) {
        throw s;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, l = !0, d = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var s = n.next();
    return l = s.done, s;
  }, e: function(s) {
    d = !0, a = s;
  }, f: function() {
    try {
      l || n.return == null || n.return();
    } finally {
      if (d) throw a;
    }
  } };
}
function Eo(e, t) {
  if (e) {
    if (typeof e == "string") return Bt(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Bt(e, t) : void 0;
  }
}
function Bt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Vt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ko(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vt(Object(n), !0).forEach(function(r) {
      _(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Po() {
  var e = /* @__PURE__ */ new Set(), t = null;
  function n(a) {
    t && (!a.canMonitor || a.canMonitor(t.canMonitorArgs)) && t.active.add(a);
  }
  function r(a) {
    var l = ko({}, a);
    e.add(l), n(l);
    function d() {
      e.delete(l), t && t.active.delete(l);
    }
    return te(d);
  }
  function i(a) {
    var l = a.eventName, d = a.payload;
    if (l === "onGenerateDragPreview") {
      t = {
        canMonitorArgs: {
          initial: d.location.initial,
          source: d.source
        },
        active: /* @__PURE__ */ new Set()
      };
      var c = Co(e), s;
      try {
        for (c.s(); !(s = c.n()).done; ) {
          var u = s.value;
          n(u);
        }
      } catch (h) {
        c.e(h);
      } finally {
        c.f();
      }
    }
    if (t) {
      for (var o = Array.from(t.active), v = 0, p = o; v < p.length; v++) {
        var f = p[v];
        if (t.active.has(f)) {
          var g;
          (g = f[l]) === null || g === void 0 || g.call(f, d);
        }
      }
      l === "onDrop" && (t.active.clear(), t = null);
    }
  }
  return {
    dispatchEvent: i,
    monitorForConsumers: r
  };
}
function Mo(e) {
  var t = e.typeKey, n = e.mount, r = e.dispatchEventToSource, i = e.onPostDispatch, a = e.defaultDropEffect, l = Po(), d = Lo({
    typeKey: t,
    defaultDropEffect: a
  });
  function c(o) {
    r == null || r(o), d.dispatchEvent(o), l.dispatchEvent(o), i == null || i(o);
  }
  function s(o) {
    var v = o.event, p = o.dragType;
    Ft.start({
      event: v,
      dragType: p,
      getDropTargetsOver: d.getIsOver,
      dispatchEvent: c
    });
  }
  function u() {
    function o() {
      var v = {
        canStart: Ft.canStart,
        start: s
      };
      return n(v);
    }
    return xo({
      typeKey: t,
      mount: o
    });
  }
  return {
    registerUsage: u,
    dropTarget: d.dropTargetForConsumers,
    monitor: l.monitorForConsumers
  };
}
var Do = te(function() {
  return navigator.userAgent.toLocaleLowerCase().includes("android");
}), Oo = "pdnd:android-fallback", Kt = "text/plain", Ao = "text/uri-list", Io = "application/vnd.pdnd", Ee = /* @__PURE__ */ new WeakMap();
function Ro(e) {
  return Ee.set(e.element, e), function() {
    Ee.delete(e.element);
  };
}
var $t = oo(), mt = Mo({
  typeKey: "element",
  defaultDropEffect: "move",
  mount: function(t) {
    return We($t.bindEvents(), me.bind(document, {
      type: "dragstart",
      listener: function(r) {
        var i, a, l, d, c, s;
        if (t.canStart(r) && !r.defaultPrevented) {
          if (!r.dataTransfer) {
            process.env.NODE_ENV !== "production" && console.warn(`
              It appears as though you have are not testing DragEvents correctly.

              - If you are unit testing, ensure you have polyfilled DragEvent.
              - If you are browser testing, ensure you are dispatching drag events correctly.

              Please see our testing guides for more information:
              https://atlassian.design/components/pragmatic-drag-and-drop/core-package/testing
            `.replace(/ {2}/g, ""));
            return;
          }
          var u = r.target;
          if (u instanceof HTMLElement) {
            var o = Ee.get(u);
            if (o) {
              var v = Se(r), p = {
                element: o.element,
                dragHandle: (i = o.dragHandle) !== null && i !== void 0 ? i : null,
                input: v
              };
              if (o.canDrag && !o.canDrag(p)) {
                r.preventDefault();
                return;
              }
              if (o.dragHandle) {
                var f = dt({
                  x: v.clientX,
                  y: v.clientY
                });
                if (!o.dragHandle.contains(f)) {
                  r.preventDefault();
                  return;
                }
              }
              var g = (a = (l = o.getInitialDataForExternal) === null || l === void 0 ? void 0 : l.call(o, p)) !== null && a !== void 0 ? a : null;
              if (g)
                for (var h = 0, y = Object.entries(g); h < y.length; h++) {
                  var x = Tn(y[h], 2), L = x[0], b = x[1];
                  r.dataTransfer.setData(L, b ?? "");
                }
              Do() && !r.dataTransfer.types.includes(Kt) && !r.dataTransfer.types.includes(Ao) && r.dataTransfer.setData(Kt, Oo), r.dataTransfer.setData(Io, "");
              var P = {
                element: o.element,
                dragHandle: (d = o.dragHandle) !== null && d !== void 0 ? d : null,
                data: (c = (s = o.getInitialData) === null || s === void 0 ? void 0 : s.call(o, p)) !== null && c !== void 0 ? c : {}
              }, w = {
                type: "element",
                payload: P,
                startedFrom: "internal"
              };
              t.start({
                event: r,
                dragType: w
              });
            }
          }
        }
      }
    }));
  },
  dispatchEventToSource: function(t) {
    var n, r, i = t.eventName, a = t.payload;
    (n = Ee.get(a.source.element)) === null || n === void 0 || (r = n[i]) === null || r === void 0 || r.call(
      n,
      // I cannot seem to get the types right here.
      // TS doesn't seem to like that one event can need `nativeSetDragImage`
      // @ts-expect-error
      a
    );
  },
  onPostDispatch: $t.getOnPostDispatch()
}), jo = mt.dropTarget, Dn = mt.monitor;
function Wo(e) {
  if (process.env.NODE_ENV !== "production" && e.dragHandle && !e.element.contains(e.dragHandle) && console.warn("Drag handle element must be contained in draggable element", {
    element: e.element,
    dragHandle: e.dragHandle
  }), process.env.NODE_ENV !== "production") {
    var t = Ee.get(e.element);
    t && console.warn("You have already registered a `draggable` on the same element", {
      existing: t,
      proposed: e
    });
  }
  var n = We(
    // making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    mt.registerUsage(),
    Ro(e),
    Mn(e.element, {
      attribute: "draggable",
      value: "true"
    })
  );
  return te(n);
}
var ke = /* @__PURE__ */ new Map(), je = /* @__PURE__ */ new Set();
function On(e) {
  Ho(e);
  var t = ke.get(e);
  if (t)
    return t;
  var n = {
    timeOfEngagementStart: Date.now()
  };
  return ke.set(e, n), n;
}
function Ho(e) {
  je.add(e);
}
function Fo(e) {
  je.clear(), e(), ke.forEach(function(t, n) {
    je.has(n) || ke.delete(n);
  }), je.clear();
}
function zo() {
  ke.clear();
}
var Xt = /* @__PURE__ */ new Map();
function No(e) {
  var t = Xt.get(e);
  if (t)
    return t;
  var n = Bo(e);
  return Xt.set(e, n), n;
}
function Bo(e) {
  var t = {
    type: "idle"
  }, n = [];
  function r(c) {
    if (t.type === "running") {
      var s = c - t.timeLastFrameFinished, u = t, o = u.latestArgs, v = dt({
        x: o.location.current.input.clientX,
        y: o.location.current.input.clientY
      });
      Fo(function() {
        n.forEach(function(p) {
          return p({
            underUsersPointer: v,
            latestArgs: o,
            timeSinceLastFrame: s
          });
        });
      }), t.timeLastFrameFinished = c, t.frameId = requestAnimationFrame(r);
    }
  }
  function i() {
    t.type !== "idle" && (cancelAnimationFrame(t.frameId), zo(), t = {
      type: "idle"
    });
  }
  function a(c) {
    t.type === "idle" && (t = {
      // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
      type: "initializing",
      latestArgs: c,
      frameId: requestAnimationFrame(function(s) {
        t.type === "initializing" && (t = {
          type: "running",
          timeLastFrameFinished: s,
          latestArgs: t.latestArgs,
          frameId: requestAnimationFrame(r)
        });
      })
    });
  }
  function l(c) {
    if (t.type === "idle") {
      a(c);
      return;
    }
    t.latestArgs = c;
  }
  e({
    onDragStart: a,
    onDropTargetChange: l,
    onDrag: l,
    onDrop: i
  });
  var d = {
    onFrame: function(s) {
      n.push(s);
    }
  };
  return d;
}
var ot = "data-auto-scrollable", Vo = "[".concat(ot, '="true"]');
function Ko(e) {
  return e.setAttribute(ot, "true"), function() {
    return e.removeAttribute(ot);
  };
}
function Zt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ut(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zt(Object(n), !0).forEach(function(r) {
      _(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var $o = {
  startHitboxAtPercentageRemainingOfElement: {
    top: 0.25,
    right: 0.25,
    bottom: 0.25,
    left: 0.25
  },
  maxScrollAtPercentageRemainingOfHitbox: {
    top: 0.5,
    right: 0.5,
    bottom: 0.5,
    left: 0.5
  },
  timeDampeningDurationMs: 400,
  // Too big and it's too easy to trigger auto scrolling
  // Too small and it's too hard 😅
  maxMainAxisHitboxSize: 180
}, Xo = {
  // What the value would be if we were scrolling at 15px per frame at 60fps.
  // This is the default as it works well for most experiences.
  // In certain scenarios though it can feel a bit slow.
  standard: 900,
  // What the value would be if we were scrolling at 25px per frame at 60fps.
  // This is not the default as it feels too fast for a lot of experiences.
  fast: 1500
};
function An(e) {
  var t;
  return Ut(Ut({}, $o), {}, {
    // only allowing limited control over the config at this stage
    maxPixelScrollPerSecond: Xo[(t = e == null ? void 0 : e.maxScrollSpeed) !== null && t !== void 0 ? t : "standard"]
  });
}
var Zo = {
  // Notes:
  //
  // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
  //    (and fractional units don't reach true integer maximum when zoomed in / out)
  // 🍎 Safari 16.5.2: no fractional units
  // 🦊 Firefox 115.0: no fractional units
  // we have some scroll we can move backwards into
  top: function(t) {
    return t.scrollTop > 0;
  },
  // We have some scroll we can move forward into
  right: function(t) {
    return Math.ceil(t.scrollLeft) + t.clientWidth < t.scrollWidth;
  },
  // We have some scroll we can move forwards into
  bottom: function(t) {
    return Math.ceil(t.scrollTop) + t.clientHeight < t.scrollHeight;
  },
  // we have some scroll we can move back into.
  left: function(t) {
    return t.scrollLeft > 0;
  }
}, Uo = ["top", "right", "bottom", "left"], Yo = {
  top: "vertical",
  right: "horizontal",
  bottom: "vertical",
  left: "horizontal"
}, Yt = {
  start: "top",
  end: "bottom",
  point: "y",
  size: "height"
}, _t = {
  start: "left",
  end: "right",
  point: "x",
  size: "width"
}, In = {
  vertical: {
    mainAxis: Yt,
    crossAxis: _t
  },
  horizontal: {
    mainAxis: _t,
    crossAxis: Yt
  }
}, pt = {
  top: "start",
  right: "end",
  bottom: "end",
  left: "start"
};
function Ie(e) {
  var t = e.edge, n = e.axis;
  return function(i) {
    var a = i.clientRect, l = i.config, d = In[n], c = d.mainAxis, s = d.crossAxis, u = pt[t], o = Math.min(
      // scale the size of the hitbox down for smaller elements
      l.startHitboxAtPercentageRemainingOfElement[t] * a[c.size],
      // Don't let the hitbox grow too big for big elements
      l.maxMainAxisHitboxSize
    );
    return DOMRect.fromRect(_(_(_(_({}, c.point, u === "start" ? (
      // begin from the start edge and grow inwards
      a[c.point]
    ) : (
      // begin from inside the end edge and grow towards the end edge
      a[c.point] + a[c.size] - o
    )), s.point, a[s.point]), c.size, o), s.size, a[s.size]));
  };
}
var _o = {
  top: Ie({
    axis: "vertical",
    edge: "top"
  }),
  right: Ie({
    axis: "horizontal",
    edge: "right"
  }),
  bottom: Ie({
    axis: "vertical",
    edge: "bottom"
  }),
  left: Ie({
    axis: "horizontal",
    edge: "left"
  })
};
function it(e) {
  var t = e.startOfRange, n = e.endOfRange, r = e.value, i = t < n;
  if (!i || r < t)
    return 0;
  if (r > n)
    return 1;
  var a = n - t;
  return (r - t) / a;
}
function Go(e) {
  var t = e.timeSinceLastFrame, n = e.config, r = n.maxPixelScrollPerSecond / 1e3, i = Math.ceil(r * t), a = n.maxPixelScrollPerSecond / 60;
  return Math.min(i, a);
}
function qo(e) {
  var t = e.client, n = e.axis, r = e.edge, i = e.hitbox, a = e.config, l = In[n].mainAxis, d = pt[r], c = i[l.size] * a.maxScrollAtPercentageRemainingOfHitbox[r];
  if (d === "end")
    return it({
      startOfRange: i[l.start],
      endOfRange: i[l.end] - c,
      value: t[l.point]
    });
  var s = it({
    startOfRange: i[l.start] + c,
    endOfRange: i[l.end],
    value: t[l.point]
  });
  return 1 - s;
}
function Re(e) {
  var t = e.client, n = e.timeSinceLastFrame, r = e.engagement, i = e.axis, a = e.hitbox, l = e.edge, d = e.isDistanceDampeningEnabled, c = e.config, s = Go({
    timeSinceLastFrame: n,
    config: c
  }), u = d ? qo({
    client: t,
    edge: l,
    hitbox: a,
    axis: i,
    config: c
  }) : 1, o = it({
    startOfRange: r.timeOfEngagementStart,
    endOfRange: r.timeOfEngagementStart + c.timeDampeningDurationMs,
    value: Date.now()
  }), v = u * o, p = Math.max(s * v, 1), f = pt[l];
  return f === "end" ? p : -1 * p;
}
function Qo(e, t) {
  return t === "all" || e === t;
}
function Jo(e) {
  var t = e.client, n = e.clientRect;
  return (
    // is within horizontal bounds
    t.x >= n.x && t.x <= n.x + n.width && // is within vertical bounds
    t.y >= n.y && t.y <= n.y + n.height
  );
}
function ei(e) {
  return e.getBoundingClientRect();
}
function Rn(e) {
  var t = e.element, n = e.input, r = e.timeSinceLastFrame, i = e.engagement, a = e.config, l = e.allowedAxis, d = e.getRect, c = d === void 0 ? ei : d, s = {
    x: n.clientX,
    y: n.clientY
  }, u = c(t), o = Uo.reduce(function(f, g) {
    var h = _o[g]({
      clientRect: u,
      config: a
    }), y = Yo[g];
    return !Qo(y, l) || !Jo({
      client: s,
      clientRect: h
    }) || !Zo[g](t) || f.set(g, {
      edge: g,
      hitbox: h
    }), f;
  }, /* @__PURE__ */ new Map()), v = (function() {
    var f = "horizontal", g = o.get("left");
    if (g)
      return Re({
        client: s,
        edge: g.edge,
        hitbox: g.hitbox,
        axis: f,
        timeSinceLastFrame: r,
        engagement: i,
        isDistanceDampeningEnabled: !0,
        config: a
      });
    var h = o.get("right");
    return h ? Re({
      client: s,
      edge: h.edge,
      hitbox: h.hitbox,
      axis: f,
      timeSinceLastFrame: r,
      engagement: i,
      isDistanceDampeningEnabled: !0,
      config: a
    }) : 0;
  })(), p = (function() {
    var f = "vertical", g = o.get("bottom");
    if (g)
      return Re({
        client: s,
        edge: g.edge,
        hitbox: g.hitbox,
        axis: f,
        timeSinceLastFrame: r,
        engagement: i,
        isDistanceDampeningEnabled: !0,
        config: a
      });
    var h = o.get("top");
    return h ? Re({
      client: s,
      edge: h.edge,
      hitbox: h.hitbox,
      axis: f,
      timeSinceLastFrame: r,
      engagement: i,
      isDistanceDampeningEnabled: !0,
      config: a
    }) : 0;
  })();
  return {
    left: v,
    top: p
  };
}
function ti(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = ni(e)) || t) {
      n && (e = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(s) {
        throw s;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, l = !0, d = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var s = n.next();
    return l = s.done, s;
  }, e: function(s) {
    d = !0, a = s;
  }, f: function() {
    try {
      l || n.return == null || n.return();
    } finally {
      if (d) throw a;
    }
  } };
}
function ni(e, t) {
  if (e) {
    if (typeof e == "string") return Gt(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Gt(e, t) : void 0;
  }
}
function Gt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function jn(e) {
  return !!(e.top || e.left);
}
function Wn(e) {
  var t, n, r, i = e.target, a = e.input, l = e.source, d = e.findEntry, c = e.timeSinceLastFrame, s = e.available, u = s === void 0 ? {
    top: !0,
    left: !0
  } : s;
  if (!jn(u) || !i)
    return u;
  var o = i.closest(Vo);
  if (!o)
    return u;
  var v = d(o);
  if (!v)
    return u;
  function p() {
    var b;
    return Wn({
      target: (b = o == null ? void 0 : o.parentElement) !== null && b !== void 0 ? b : null,
      findEntry: d,
      source: l,
      timeSinceLastFrame: c,
      input: a,
      available: u
    });
  }
  var f = {
    input: a,
    source: l,
    element: o
  };
  if (v.canScroll && !v.canScroll(f))
    return p();
  var g = On(o), h = An((t = v.getConfiguration) === null || t === void 0 ? void 0 : t.call(v, f)), y = (n = (r = v.getAllowedAxis) === null || r === void 0 ? void 0 : r.call(v, f)) !== null && n !== void 0 ? n : "all", x = Rn({
    element: o,
    engagement: g,
    input: a,
    timeSinceLastFrame: c,
    allowedAxis: y,
    config: h
  }), L = {
    top: 0,
    left: 0
  };
  return u.top && x.top !== 0 && (L.top = x.top, u.top = !1), u.left && x.left !== 0 && (L.left = x.left, u.left = !1), (L.top !== 0 || L.left !== 0) && o.scrollBy(L), p();
}
function ri(e) {
  var t = e.input, n = e.timeSinceLastFrame, r = e.available, i = e.source, a = e.entries, l = document.documentElement, d = {
    input: t,
    source: i,
    element: l
  }, c = ti(a), s;
  try {
    for (c.s(); !(s = c.n()).done; ) {
      var u, o, v, p = s.value;
      if (!(p.canScroll && !p.canScroll(d))) {
        var f = On(l), g = An((u = p.getConfiguration) === null || u === void 0 ? void 0 : u.call(p, d)), h = (o = (v = p.getAllowedAxis) === null || v === void 0 ? void 0 : v.call(p, d)) !== null && o !== void 0 ? o : "all", y = Rn({
          element: l,
          engagement: f,
          input: t,
          config: g,
          allowedAxis: h,
          getRect: function(b) {
            return DOMRect.fromRect({
              y: 0,
              x: 0,
              width: b.clientWidth,
              height: b.clientHeight
            });
          },
          timeSinceLastFrame: n
        }), x = {
          top: r.top ? y.top : 0,
          left: r.left ? y.left : 0
        };
        (x.top !== 0 || x.left !== 0) && l.scrollBy(x);
        break;
      }
    }
  } catch (L) {
    c.e(L);
  } finally {
    c.f();
  }
}
function oi(e) {
  var t = e.input, n = e.findEntry, r = e.timeSinceLastFrame, i = e.source, a = e.getWindowScrollEntries, l = e.underUsersPointer, d = Wn({
    target: l,
    timeSinceLastFrame: r,
    input: t,
    source: i,
    findEntry: n
  });
  jn(d) && ri({
    input: t,
    source: i,
    entries: a(),
    timeSinceLastFrame: r,
    available: d
  });
}
function qt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ii(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qt(Object(n), !0).forEach(function(r) {
      _(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ai(e) {
  var t = e.monitor, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set();
  function i(s) {
    if (process.env.NODE_ENV !== "production") {
      var u = window.getComputedStyle(s.element), o = u.overflowX, v = u.overflowY, p = o === "auto" || o === "scroll" || v === "auto" || v === "scroll";
      p || console.warn("Auto scrolling has been attached to an element that appears not to be scrollable", {
        element: s.element,
        overflowX: o,
        overflowY: v
      });
    }
    if (process.env.NODE_ENV !== "production") {
      var f = n.get(s.element);
      f && console.warn("You have already registered autoScrolling on the same element", {
        existing: f,
        proposed: s
      });
    }
    n.set(s.element, s);
    var g = We(Ko(s.element), function() {
      return n.delete(s.element);
    });
    return te(g);
  }
  function a() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = ii({}, s);
    r.add(u);
    function o() {
      r.delete(u);
    }
    return te(o);
  }
  function l(s) {
    var u;
    return (u = n.get(s)) !== null && u !== void 0 ? u : null;
  }
  function d() {
    return Array.from(r);
  }
  function c(s) {
    var u = s.latestArgs, o = s.underUsersPointer, v = s.timeSinceLastFrame;
    oi({
      input: u.location.current.input,
      source: u.source,
      findEntry: l,
      underUsersPointer: o,
      timeSinceLastFrame: v,
      getWindowScrollEntries: d
    });
  }
  return No(t).onFrame(c), {
    autoScroll: i,
    autoScrollWindow: a
  };
}
var ci = ai({
  monitor: Dn
}), si = ci.autoScroll;
function li(e) {
  const { store: t } = K(), n = C((a) => a.setZoomLevel), r = C((a) => a.setScrollPosition), i = O(
    (a) => {
      if (!a.ctrlKey && !a.metaKey) return;
      a.preventDefault();
      const l = t.getState(), d = vn(l), { currentTime: c, duration: s, zoomLevel: u, scrollPosition: o } = l;
      if (s === 0) return;
      const p = Math.pow(2, -a.deltaY * 5e-3), f = u * p, g = Math.max(ce, Math.min(f, d));
      if (g === u) return;
      const h = e.current;
      if (!h) return;
      const y = g / u, { newScroll: x } = dn(
        u,
        y,
        c,
        o,
        s,
        h.getBoundingClientRect().width
      );
      n(g), r(x);
    },
    [e, n, r, t]
  );
  B(() => {
    const a = e.current;
    if (a)
      return a.addEventListener("wheel", i, { passive: !1 }), () => {
        a.removeEventListener("wheel", i);
      };
  }, [e, i]);
}
function ui(e) {
  const { store: t } = K(), n = O(
    (s) => {
      if (s.ctrlKey || s.metaKey || !s.shiftKey && Math.abs(s.deltaX) <= 0)
        return;
      const u = Math.abs(s.deltaX) > 0 ? s.deltaX : s.deltaY;
      s.preventDefault();
      const { scrollPosition: o, duration: v, setScrollPosition: p } = t.getState(), f = Z(t.getState()), g = xe(t.getState()), h = u / f, y = o + h, x = le(v, g, f);
      p(Math.max(0, Math.min(y, x)));
    },
    [t]
  ), r = R(!1), i = R(0), a = R(0), l = O(
    (s) => {
      s.button === 1 && (s.preventDefault(), r.current = !0, i.current = s.clientX, a.current = t.getState().scrollPosition, document.body.style.cursor = "grabbing");
    },
    [t]
  ), d = O(
    (s) => {
      if (!r.current) return;
      const u = i.current - s.clientX, { duration: o, setScrollPosition: v } = t.getState(), p = Z(t.getState()), f = xe(t.getState()), g = u / p, h = a.current + g, y = le(o, f, p);
      v(Math.max(0, Math.min(h, y)));
    },
    [t]
  ), c = O(() => {
    r.current && (r.current = !1, document.body.style.cursor = "");
  }, []);
  B(() => {
    const s = e.current;
    if (s)
      return s.addEventListener("wheel", n, { passive: !1 }), s.addEventListener("mousedown", l), document.addEventListener("mousemove", d), document.addEventListener("mouseup", c), () => {
        s.removeEventListener("wheel", n), s.removeEventListener("mousedown", l), document.removeEventListener("mousemove", d), document.removeEventListener("mouseup", c);
      };
  }, [e, n, l, d, c]);
}
function di(e, t) {
  B(() => {
    const n = e.current, r = t.current;
    if (!n || !r) return;
    const i = () => {
      r.scrollTop = n.scrollTop;
    }, a = () => {
      n.scrollTop = r.scrollTop;
    };
    return n.addEventListener("scroll", i), r.addEventListener("scroll", a), () => {
      n.removeEventListener("scroll", i), r.removeEventListener("scroll", a);
    };
  }, [e, t]);
}
function F(e) {
  return e === "video" || e === "audio";
}
function fi(e, t, n, r, i) {
  const a = Math.round(e * i) / i;
  let l = a, d = r, c = null;
  for (const s of n) {
    const u = Math.abs(a - s);
    u < d && (d = u, l = s, c = s);
    const o = Math.abs(a + t - s);
    o < d && (d = o, l = s - t, c = s);
  }
  return { startTime: l, snapIndicator: c };
}
function mi(e, t, n, r, i, a, l, d) {
  const c = 1 / d;
  let s = t + e, u = i;
  if (F(n) && (u = i - e, u < 0 && (s = t + i, u = 0)), s < c) {
    const g = c - s;
    s = c, F(n) && (u += g);
  }
  const o = r + s, { snappedEdge: v, snapIndicator: p } = gt(o, a, l), f = v - o;
  return f !== 0 && (s += f, F(n) && (u -= f), F(n) && u < 0 && (s += u, u = 0), s < c && (F(n) && (u += c - s), s = c)), s = Math.round(s * d) / d, F(n) && (u = t + i - s), { duration: s, trimEnd: u, snapIndicator: p };
}
function pi(e, t, n, r, i, a, l, d) {
  const c = 1 / d;
  let s = r + e, u = t - e, o = i;
  if (F(n) && (o = i + e, o < 0 && (s = r - i, u = t + i, o = 0)), s < 0) {
    const h = -s;
    s = 0, u -= h, F(n) && (o += h);
  }
  if (u < c) {
    const h = c - u;
    u = c, s -= h, F(n) && (o -= h), s < 0 && (s = 0), F(n) && o < 0 && (o = 0);
  }
  const v = s, { snappedEdge: p, snapIndicator: f } = gt(v, a, l), g = p - v;
  if (g !== 0 && (s += g, u -= g, F(n) && (o += g), F(n) && o < 0 && (s -= o, u += o, o = 0), s < 0 && (u += s, F(n) && (o -= s), s = 0), u < c)) {
    const h = c - u;
    u = c, s -= h, F(n) && (o -= h), s < 0 && (s = 0), F(n) && o < 0 && (o = 0);
  }
  return s = Math.round(s * d) / d, u = r + t - s, F(n) && (o = i + t - u), { startTime: s, duration: u, trimStart: o, snapIndicator: f };
}
function Hn(e, t, n, r = []) {
  const i = [...r];
  for (const a of e)
    a.id !== t && i.push(a.startTime, Math.round((a.startTime + a.duration) * n) / n);
  return i;
}
function gt(e, t, n) {
  let r = e, i = n, a = null;
  for (const l of t) {
    const d = Math.abs(e - l);
    d < i && (i = d, r = l, a = l);
  }
  return { snappedEdge: r, snapIndicator: a };
}
const gi = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m("path", { d: "M12 5.25V18.75", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M5.25 8.25V5.25H18.75V8.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m("path", { d: "M9 18.75H15", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" })
] }), hi = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M5.31494 20.2499L15.5946 9.96923C15.6643 9.8995 15.747 9.84418 15.838 9.80644C15.9291 9.76869 16.0267 9.74927 16.1253 9.74927C16.2238 9.74927 16.3214 9.76869 16.4125 9.80644C16.5035 9.84418 16.5862 9.8995 16.6559 9.96923L20.2503 13.5645",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), vi = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M14.8 12.5L10 9.5V15.5L14.8 12.5Z",
      stroke: "currentColor",
      strokeWidth: "1.13",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M20.1818 5H3.81818C3.36631 5 3 5.47969 3 6.07143V18.9286C3 19.5203 3.36631 20 3.81818 20H20.1818C20.6337 20 21 19.5203 21 18.9286V6.07143C21 5.47969 20.6337 5 20.1818 5Z",
      stroke: "currentColor",
      strokeWidth: "1.13",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), yi = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M12 5.25C4.5 5.25 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C19.5 18.75 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), bi = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M3 9.75C4.57594 11.7009 7.46531 14.25 12 14.25C16.5347 14.25 19.4241 11.7009 21 9.75",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M21 15.7499L18.8081 11.9146",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M15.0001 17.9998L14.3354 14.0107",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M9 17.9998L9.66469 14.0107",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M3 15.7499L5.19187 11.9146",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Si = ({
  onToggle: e,
  hidden: t,
  disabled: n
}) => /* @__PURE__ */ m(se, { size: 20, disabled: n, onClick: e, stopPropagation: !0, children: t ? /* @__PURE__ */ m(bi, { width: 14, height: 14 }) : /* @__PURE__ */ m(yi, { width: 14, height: 14 }) }), wi = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M8.25 8.25V5.25C8.25 4.25544 8.64509 3.30161 9.34835 2.59835C10.0516 1.89509 11.0054 1.5 12 1.5C12.9946 1.5 13.9484 1.89509 14.6517 2.59835C15.3549 3.30161 15.75 4.25544 15.75 5.25V8.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), xi = ({ title: e, ...t }) => /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M8.25 8.25V5.25C8.25 4.25544 8.64509 3.30161 9.34835 2.59835C10.0516 1.89509 11.0054 1.5 12 1.5C13.8141 1.5 15.4022 2.78812 15.75 4.5",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Ti = ({
  onToggle: e,
  locked: t,
  disabled: n
}) => /* @__PURE__ */ m(se, { size: 20, disabled: n, onClick: e, stopPropagation: !0, children: t ? /* @__PURE__ */ m(wi, { width: 14, height: 14 }) : /* @__PURE__ */ m(xi, { width: 14, height: 14 }) });
function Li() {
  const e = C((g) => g.zoomLevel), t = C(vn), n = C((g) => g.setZoomLevel), r = C((g) => g.scrollPosition), i = C((g) => g.currentTime), a = C((g) => g.duration), l = C((g) => g.containerWidth), d = C((g) => g.setScrollPosition), c = (g) => {
    const h = g / e, { newScroll: y } = dn(e, h, i, r, a, l);
    n(g), d(y);
  }, s = () => {
    c(Math.min(e * Tt, t));
  }, u = () => {
    c(Math.max(e / Tt, ce));
  }, o = Math.log(ce), v = Math.log(Math.max(t, ce + gr)), p = (Math.log(e) - o) / (v - o), f = (g) => {
    const h = parseFloat(g.target.value), y = Math.exp(o + h * (v - o));
    c(y);
  };
  return /* @__PURE__ */ M(J, { style: { gap: 4, height: "100%", paddingRight: "8px" }, onMouseDown: (g) => g.stopPropagation(), children: [
    /* @__PURE__ */ m(
      ue,
      {
        component: "button",
        className: "zoom-button",
        style: {
          width: 12,
          height: 12,
          flexShrink: 0,
          padding: 0,
          border: "none",
          borderRadius: "50%",
          background: "transparent",
          color: Te,
          cursor: "pointer"
        },
        onClick: u,
        disabled: e <= ce,
        "aria-label": "Zoom out",
        children: /* @__PURE__ */ M("svg", { viewBox: "0 0 12 12", width: "12", height: "12", children: [
          /* @__PURE__ */ m("circle", { cx: "6", cy: "6", r: "5", fill: "none", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ m("line", { x1: "3.5", y1: "6", x2: "8.5", y2: "6", stroke: "currentColor", strokeWidth: "1.2" })
        ] })
      }
    ),
    /* @__PURE__ */ m(
      "input",
      {
        className: "zoom-slider",
        type: "range",
        min: "0",
        max: "1",
        step: "0.001",
        value: p,
        onChange: f,
        "aria-label": "Zoom level",
        style: {
          WebkitAppearance: "none",
          appearance: "none",
          flex: 1,
          minWidth: 0,
          height: 6,
          borderRadius: 3,
          background: N,
          outline: "none",
          cursor: "pointer"
        }
      }
    ),
    /* @__PURE__ */ m(
      ue,
      {
        component: "button",
        className: "zoom-button",
        style: {
          width: 12,
          height: 12,
          flexShrink: 0,
          padding: 0,
          border: "none",
          borderRadius: "50%",
          background: "transparent",
          color: Te,
          cursor: "pointer"
        },
        onClick: s,
        disabled: e >= t,
        "aria-label": "Zoom in",
        children: /* @__PURE__ */ M("svg", { viewBox: "0 0 12 12", width: "12", height: "12", children: [
          /* @__PURE__ */ m("circle", { cx: "6", cy: "6", r: "5", fill: "none", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ m("line", { x1: "3.5", y1: "6", x2: "8.5", y2: "6", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ m("line", { x1: "6", y1: "3.5", x2: "6", y2: "8.5", stroke: "currentColor", strokeWidth: "1.2" })
        ] })
      }
    )
  ] });
}
const Ci = 4, Qt = gn * 2 + pn + Ci;
function Ei() {
  const e = C((y) => y.scrollPosition), t = C((y) => y.duration), n = C((y) => y.containerWidth), r = C(xe), i = C(Z), a = C((y) => y.setScrollPosition), { store: l } = K(), d = R(null), c = Math.max(0, n - Qt), s = t > 0 ? r / t : 1, u = Math.max(xt, c * s), o = le(t, r, i), v = o > 0 ? e / o * (c - u) : 0, p = R({ active: !1, startMouseX: 0, startThumbLeft: 0 }), f = R(null);
  if (B(() => {
    const y = (L) => {
      if (!p.current.active) return;
      const b = l.getState(), { duration: P, containerWidth: w, setScrollPosition: T } = b, S = xe(b), E = Z(b), A = Math.max(0, w - Qt), k = P > 0 ? S / P : 1, D = Math.max(xt, A * k), I = le(P, S, E), H = L.clientX - p.current.startMouseX, z = A - D;
      if (z <= 0) return;
      const V = Math.max(0, Math.min(p.current.startThumbLeft + H, z)) / z;
      T(V * I);
    }, x = () => {
      p.current.active && (p.current.active = !1, document.removeEventListener("mousemove", y), document.removeEventListener("mouseup", x));
    };
    f.current = { onMouseMove: y, onMouseUp: x };
  }, [l]), r >= t) return null;
  function g(y) {
    if (y.button !== 0) return;
    y.stopPropagation();
    const x = f.current;
    x && (p.current = {
      active: !0,
      startMouseX: y.clientX,
      startThumbLeft: v
    }, document.addEventListener("mousemove", x.onMouseMove), document.addEventListener("mouseup", x.onMouseUp));
  }
  function h(y) {
    const x = d.current;
    if (!x) return;
    const L = x.getBoundingClientRect(), b = y.clientX - L.left, P = c - u;
    if (P <= 0) return;
    const T = Math.max(0, Math.min(b - u / 2, P)) / P;
    a(T * o);
  }
  return /* @__PURE__ */ m(
    "div",
    {
      ref: d,
      className: "timeline-scrollbar",
      style: {
        position: "relative",
        flex: 1,
        minWidth: 0,
        height: 6,
        margin: "auto 4px auto 0",
        background: N,
        borderRadius: 3,
        cursor: "pointer"
      },
      onMouseDown: h,
      children: /* @__PURE__ */ m(
        "div",
        {
          style: {
            position: "absolute",
            top: 0,
            height: "100%",
            borderRadius: 3,
            background: fe,
            cursor: "grab",
            transition: "background 0.15s",
            width: u,
            left: v
          },
          onMouseDown: g
        }
      )
    }
  );
}
function ki(e) {
  return e.type === "video" ? { background: kr } : e.type === "audio" ? { background: Pr } : e.type === "text" ? { background: Er } : {
    background: `url(${e.thumbnailUrl})`,
    backgroundSize: "32px 32px",
    backgroundRepeat: "repeat"
  };
}
function Qe(e, t) {
  const n = t.getBoundingClientRect();
  return e - n.left < St ? "trim-left" : n.right - e < St ? "trim-right" : "move";
}
function Pi({ track: e, isSelected: t }) {
  const n = C((k) => k.scrollPosition), r = C((k) => k.containerWidth), i = C(Z), a = C((k) => k.setTrackTrim), { store: l, onTrackStartTimeChange: d, onTrackTrimChange: c, onTrackSelect: s } = K(), u = R({
    active: !1,
    mode: "move",
    trackId: -1,
    trackType: "image",
    trackDuration: 0,
    initialStartTime: 0,
    initialTrimStart: 0,
    initialTrimEnd: 0,
    mouseDownClientX: 0,
    lastSnappedStartTime: 0,
    // For trim: track last-applied values to avoid duplicate updates
    lastDuration: 0,
    lastTrimStart: 0,
    lastTrimEnd: 0
  }), o = O(
    (k) => {
      if (k.button !== 0 || (k.stopPropagation(), e.locked)) return;
      document.activeElement instanceof HTMLElement && document.activeElement.blur(), s(e.id);
      const D = k.currentTarget, I = Qe(k.clientX, D);
      u.current = {
        active: !0,
        mode: I,
        trackId: e.id,
        trackType: e.type,
        trackDuration: e.duration,
        initialStartTime: e.startTime,
        initialTrimStart: e.trimStart ?? 0,
        initialTrimEnd: e.trimEnd ?? 0,
        mouseDownClientX: k.clientX,
        lastSnappedStartTime: e.startTime,
        lastDuration: e.duration,
        lastTrimStart: e.trimStart ?? 0,
        lastTrimEnd: e.trimEnd ?? 0
      };
      const { setDraggingTrackId: H } = l.getState();
      H(e.id), I === "move" ? document.body.classList.add("timeline-dragging") : document.body.classList.add("timeline-trimming");
      const z = (V) => {
        if (!u.current.active) return;
        const ne = l.getState(), { frameRate: re, setTrackStartTime: pe, setTrackTrim: Pe, setSnapIndicatorTime: ge } = ne, ae = Z(ne), Me = V.clientX - u.current.mouseDownClientX, He = ae > 0 ? Me / ae : 0, Fe = (V.shiftKey ? mn : fn) / ae, { tracks: Fn, currentTime: zn, duration: Nn } = l.getState(), ze = Hn(Fn, u.current.trackId, re, [
          zn,
          0,
          Nn
        ]), { mode: Ne, trackType: De, initialStartTime: he, initialTrimStart: ht, initialTrimEnd: vt, trackDuration: Be } = u.current;
        if (Ne === "move") {
          const W = he + He, $ = fi(W, Be, ze, Fe, re);
          if (ge($.snapIndicator), $.startTime === u.current.lastSnappedStartTime) return;
          u.current.lastSnappedStartTime = $.startTime, pe(u.current.trackId, $.startTime), d(u.current.trackId, $.startTime, !0);
        } else if (Ne === "trim-right") {
          const W = mi(
            He,
            Be,
            De,
            he,
            vt,
            ze,
            Fe,
            re
          );
          if (ge(W.snapIndicator), W.duration === u.current.lastDuration && W.trimEnd === u.current.lastTrimEnd)
            return;
          u.current.lastDuration = W.duration, u.current.lastTrimEnd = W.trimEnd, u.current.lastSnappedStartTime = he;
          const $ = {
            startTime: he,
            duration: W.duration,
            ...F(De) ? { trimStart: ht, trimEnd: W.trimEnd } : {}
          };
          Pe(u.current.trackId, $), c(u.current.trackId, $, !0);
        } else if (Ne === "trim-left") {
          const W = pi(
            He,
            Be,
            De,
            he,
            ht,
            ze,
            Fe,
            re
          );
          if (ge(W.snapIndicator), W.startTime === u.current.lastSnappedStartTime && W.duration === u.current.lastDuration && W.trimStart === u.current.lastTrimStart)
            return;
          u.current.lastSnappedStartTime = W.startTime, u.current.lastDuration = W.duration, u.current.lastTrimStart = W.trimStart;
          const $ = {
            startTime: W.startTime,
            duration: W.duration,
            ...F(De) ? { trimStart: W.trimStart, trimEnd: vt } : {}
          };
          Pe(u.current.trackId, $), c(u.current.trackId, $, !0);
        }
      }, j = () => {
        if (!u.current.active) return;
        const { mode: V } = u.current;
        u.current.active = !1, document.body.classList.remove("timeline-dragging"), document.body.classList.remove("timeline-trimming");
        const { setSnapIndicatorTime: ne, setDraggingTrackId: re } = l.getState();
        if (ne(null), re(null), V === "move")
          d(u.current.trackId, u.current.lastSnappedStartTime, !1);
        else {
          const pe = {
            startTime: u.current.lastSnappedStartTime,
            duration: u.current.lastDuration,
            ...F(u.current.trackType) ? { trimStart: u.current.lastTrimStart, trimEnd: u.current.lastTrimEnd } : {}
          };
          c(u.current.trackId, pe, !1);
        }
        document.removeEventListener("mousemove", z), document.removeEventListener("mouseup", j);
      };
      document.addEventListener("mousemove", z), document.addEventListener("mouseup", j);
    },
    [e, s, d, c, l]
  ), v = O(
    (k) => {
      if (e.locked) return;
      const D = k.currentTarget, I = Qe(k.clientX, D), H = e.trimStart ?? 0, z = e.trimEnd ?? 0;
      let j = null;
      I === "trim-left" && H > 0 ? j = {
        startTime: e.startTime - H,
        duration: e.duration + H,
        trimStart: 0,
        trimEnd: z
      } : I === "trim-right" && z > 0 && (j = {
        startTime: e.startTime,
        duration: e.duration + z,
        trimStart: H,
        trimEnd: 0
      }), j && (a(e.id, j), c(e.id, j, !1));
    },
    [e, a, c]
  ), p = O(
    (k) => {
      if (e.locked || u.current.active) return;
      const D = k.currentTarget, I = Qe(k.clientX, D);
      D.style.cursor = I === "move" ? "grab" : "ew-resize";
    },
    [e.locked]
  ), f = O(
    (k) => {
      if (u.current.active) return;
      const D = k.currentTarget;
      D.style.cursor = e.locked ? "not-allowed" : "grab";
    },
    [e.locked]
  ), g = (e.startTime - n) * i, h = g + e.duration * i, y = Math.max(0, g), x = Math.max(0, Math.min(h, r) - y), L = ki(e), b = y - g, P = e.trimStart ?? 0, w = e.trimEnd ?? 0, T = P * i, S = g - T, E = h, A = w * i;
  return /* @__PURE__ */ M(
    "div",
    {
      "data-track-id": e.id,
      style: {
        position: "relative",
        height: ut,
        background: X,
        borderBottom: `1px solid ${N}`,
        boxSizing: "border-box"
      },
      children: [
        P > 0 && /* @__PURE__ */ m(
          "div",
          {
            style: {
              position: "absolute",
              height: $e,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: `${ve}px 0 0 ${ve}px`,
              pointerEvents: "none",
              left: Math.max(0, S),
              width: Math.max(0, Math.min(S + T, r) - Math.max(0, S)),
              background: L.background,
              backgroundSize: L.backgroundSize,
              backgroundRepeat: L.backgroundRepeat,
              opacity: wt
            }
          }
        ),
        e.duration > 0 && /* @__PURE__ */ m(
          "div",
          {
            className: `timeline-track-clip${t ? " selected" : ""}`,
            style: {
              position: "absolute",
              height: $e,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: ve,
              overflow: "hidden",
              cursor: e.locked ? "not-allowed" : "grab",
              left: y,
              width: x,
              background: L.background,
              backgroundSize: L.backgroundSize,
              backgroundRepeat: L.backgroundRepeat,
              backgroundPosition: b > 0 ? `${-b}px 0` : void 0,
              opacity: e.hidden || e.type === "audio" && e.muted ? 0.5 : void 0
            },
            onMouseDown: o,
            onDoubleClick: v,
            onMouseMove: p,
            onMouseLeave: f,
            children: e.label && /* @__PURE__ */ m(
              J,
              {
                component: "span",
                style: {
                  height: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  pointerEvents: "none",
                  userSelect: "none",
                  ...e.type === "text" ? { alignItems: "flex-start", padding: "4px 8px 0", color: xr } : { padding: "0 6px", color: X },
                  ...b > 0 ? { marginLeft: -b } : void 0
                },
                children: e.type === "text" && /* @__PURE__ */ m(Hr, { text: e.label })
              }
            )
          }
        ),
        w > 0 && /* @__PURE__ */ m(
          "div",
          {
            style: {
              position: "absolute",
              height: $e,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: `0 ${ve}px ${ve}px 0`,
              pointerEvents: "none",
              left: Math.max(0, E),
              width: Math.max(0, Math.min(E + A, r) - Math.max(0, E)),
              background: L.background,
              backgroundSize: L.backgroundSize,
              backgroundRepeat: L.backgroundRepeat,
              opacity: wt
            }
          }
        )
      ]
    }
  );
}
function Mi() {
  const e = C((a) => a.snapIndicatorTime), t = C((a) => a.scrollPosition), n = C(Z), r = C((a) => a.containerWidth);
  if (e === null) return null;
  const i = (e - t) * n;
  return i < -1 || i > r + 1 ? null : /* @__PURE__ */ m(
    "div",
    {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 9,
        transform: `translateX(${i}px)`
      },
      children: /* @__PURE__ */ m(
        "div",
        {
          style: {
            position: "absolute",
            top: q,
            left: 0,
            width: 1,
            bottom: 0,
            background: de
          }
        }
      )
    }
  );
}
const Di = 15, Jt = q - Di;
function Oi() {
  const e = C((l) => l.currentTime), t = C((l) => l.scrollPosition), n = C(Z), r = (e - t) * n, i = C((l) => l.duration), a = C((l) => l.containerWidth);
  return i === 0 || r < -10 || r > a + 10 ? null : /* @__PURE__ */ M(
    "div",
    {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 10,
        transform: `translateX(${r}px)`
      },
      children: [
        /* @__PURE__ */ m(
          "div",
          {
            style: {
              position: "absolute",
              top: Jt,
              left: -6,
              width: 12,
              height: 8,
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderTop: `8px solid ${de}`,
              pointerEvents: "auto"
            }
          }
        ),
        /* @__PURE__ */ m(
          "div",
          {
            style: {
              position: "absolute",
              top: Jt,
              left: -1,
              width: 1,
              bottom: 0,
              background: de
            }
          }
        )
      ]
    }
  );
}
function Ai() {
  const e = C((c) => c.duration), t = C((c) => c.frameRate), n = C((c) => c.scrollPosition), r = C((c) => c.containerWidth), i = C(xe), a = C(Z), { ticks: l, majorInterval: d } = Je(() => {
    if (e === 0 || r === 0) return { ticks: [], majorInterval: 0 };
    const { start: c, end: s } = ar(n, i, e), { interval: u, majorInterval: o } = ur(a, t);
    return {
      ticks: dr(c, s, u, o, t),
      majorInterval: o
    };
  }, [e, t, n, i, a, r]);
  return e === 0 ? /* @__PURE__ */ m("div", { style: { display: "block", borderBottom: `1px solid ${N}`, height: q }, children: /* @__PURE__ */ m(ue, { component: "span", style: { height: "100%" }, children: /* @__PURE__ */ m(Rr, { text: "No timeline data" }) }) }) : /* @__PURE__ */ M(
    "svg",
    {
      width: r,
      height: q,
      style: { display: "block", borderBottom: `1px solid ${N}` },
      children: [
        /* @__PURE__ */ m("rect", { x: 0, y: 0, width: r, height: q, fill: X }),
        l.map((c, s) => {
          if (c.isMajor && c.time === 0) return null;
          const u = (c.time - n) * a;
          if (c.isMajor)
            return c.label ? /* @__PURE__ */ m(
              "text",
              {
                x: u,
                y: q / 2 - 2,
                fill: fe,
                fontSize: "0.75rem",
                dominantBaseline: "central",
                children: c.label
              },
              `${c.time}-${s}`
            ) : null;
          const o = Math.round(c.time / d) * d;
          if (Math.abs(c.time - o) * a < pr) return null;
          const p = q - 12;
          return /* @__PURE__ */ m("rect", { x: u, y: p, width: 1, height: 2, fill: fe }, `${c.time}-${s}`);
        })
      ]
    }
  );
}
const we = "timeline-sidebar";
function Ii({ trackId: e, displayIndex: t, children: n }) {
  const r = R(null), [i, a] = ee();
  return B(() => {
    if (!r.current) return;
    const l = Wo({
      element: r.current,
      getInitialData: () => ({ type: we, trackId: e, displayIndex: t })
    }), d = jo({
      element: r.current,
      getData: () => ({ type: we, trackId: e, displayIndex: t }),
      canDrop: ({ source: c }) => c.data.type === we && c.data.trackId !== e,
      onDragEnter: ({ source: c }) => {
        a(Number(c.data.displayIndex) > t ? "top" : "bottom");
      },
      onDragLeave: () => a(void 0),
      onDrop: () => a(void 0)
    });
    return () => {
      l(), d();
    };
  }, [e, t]), /* @__PURE__ */ M("div", { ref: r, style: { position: "relative" }, children: [
    i && /* @__PURE__ */ m(
      "div",
      {
        style: {
          position: "absolute",
          left: 0,
          right: 0,
          [i === "top" ? "top" : "bottom"]: 0,
          height: 2,
          background: bn,
          zIndex: 1,
          pointerEvents: "none"
        }
      }
    ),
    n
  ] });
}
const Ri = {
  text: gi,
  image: hi,
  video: vi,
  audio: Sn
};
function ji({ track: e }) {
  const { onTrackSelect: t } = K(), n = Ri[e.type];
  return /* @__PURE__ */ M(
    J,
    {
      style: {
        height: ut,
        justifyContent: "space-between",
        cursor: "pointer",
        padding: "0 8px",
        color: be,
        borderBottom: `1px solid ${N}`,
        boxSizing: "border-box"
      },
      onMouseDown: (r) => {
        r.stopPropagation(), !e.locked && (document.activeElement instanceof HTMLElement && document.activeElement.blur(), t(e.id));
      },
      children: [
        /* @__PURE__ */ M(ie, { style: { gap: "4px" }, children: [
          /* @__PURE__ */ m(
            n,
            {
              style: { flexShrink: 0 },
              width: 16,
              height: 16,
              color: e.hidden ? fe : be
            }
          ),
          /* @__PURE__ */ m(
            J,
            {
              style: {
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: e.hidden ? fe : be
              },
              children: /* @__PURE__ */ m(Wr, { text: e.name })
            }
          )
        ] }),
        /* @__PURE__ */ M(ie, { style: { gap: "2px" }, children: [
          /* @__PURE__ */ m(Wi, { track: e }),
          /* @__PURE__ */ m(Hi, { track: e }),
          /* @__PURE__ */ m(Fi, { track: e })
        ] })
      ]
    }
  );
}
function Wi({ track: e }) {
  const { onTrackMuteToggle: t } = K();
  if (e.type !== "video" && e.type !== "audio") return null;
  const n = e.muted ?? !1;
  return /* @__PURE__ */ m(wn, { onToggle: () => t(e.id, !n), muted: n, size: "medium" });
}
function Hi({ track: e }) {
  const { onTrackVisibilityToggle: t } = K();
  if (e.type === "audio") return null;
  const n = e.hidden;
  return /* @__PURE__ */ m(Si, { onToggle: () => t(e.id, !n), hidden: n });
}
function Fi({ track: e }) {
  const { onTrackLockToggle: t, onTrackSelect: n, selectedTrackId: r } = K(), i = e.locked;
  return /* @__PURE__ */ m(
    Ti,
    {
      onToggle: () => {
        const a = !i;
        t(e.id, a), a && r === e.id && n(null);
      },
      locked: i
    }
  );
}
function Yi() {
  const e = R(null), t = R(null), n = R(null), r = C((f) => f.duration), i = C((f) => f.setContainerWidth), a = C((f) => f.tracks), { store: l, onSeek: d, onTrackSelect: c, onTrackReorder: s, selectedTrackId: u } = K();
  li(e), ui(e), B(() => {
    const f = e.current;
    if (!f) return;
    const g = () => {
      i(f.clientWidth);
    };
    g();
    const h = new ResizeObserver(g);
    return h.observe(f), () => h.disconnect();
  }, [i]), di(t, n), B(() => Dn({
    canMonitor: ({ source: f }) => f.data.type === we,
    onDrop: ({ source: f, location: g }) => {
      const h = g.current.dropTargets[0];
      if (!h) return;
      const y = f.data.trackId, x = h.data.trackId;
      typeof y != "number" || typeof x != "number" || y !== x && s(y, x);
    }
  }), [s]), B(() => {
    const f = n.current;
    if (f)
      return si({
        element: f,
        canScroll: ({ source: g }) => g.data.type === we
      });
  }, []);
  const o = R({
    active: !1,
    wasPlaying: !1
  }), v = O(
    (f) => {
      const g = l.getState();
      if (f.button !== 0 || g.duration === 0) return;
      o.current.active = !0, o.current.wasPlaying = g.isPlaying, document.body.style.cursor = "ew-resize", g.isPlaying && g.setPlaying(!1);
      function h(L, b = !1) {
        const P = e.current;
        if (!P) return;
        const w = l.getState(), { scrollPosition: T, duration: S, frameRate: E, tracks: A, setCurrentTime: k, setSnapIndicatorTime: D } = w, I = Z(w), H = P.getBoundingClientRect(), z = L - H.left, j = cr(z, T, I), V = Math.round(j * E) / E, ne = Math.max(0, Math.min(V, S)), pe = (b ? mn : fn) / I, Pe = Hn(A, -1, E, [0, S]), { snappedEdge: ge, snapIndicator: ae } = gt(ne, Pe, pe);
        D(ae);
        const Me = ae !== null ? ge : ne;
        k(Me), d(Me);
      }
      const y = (L) => {
        o.current.active && h(L.clientX, L.shiftKey);
      }, x = () => {
        if (!o.current.active) return;
        o.current.active = !1, document.body.style.cursor = "";
        const { setSnapIndicatorTime: L, setPlaying: b } = l.getState();
        L(null), o.current.wasPlaying && b(!0), document.removeEventListener("mousemove", y), document.removeEventListener("mouseup", x);
      };
      h(f.clientX, f.shiftKey), document.addEventListener("mousemove", y), document.addEventListener("mouseup", x);
    },
    [d, l]
  ), p = O(() => c(null), [c]);
  return /* @__PURE__ */ m(
    Sr,
    {
      className: "timeline-container",
      style: {
        flex: 1,
        minHeight: 0,
        background: X,
        borderTop: `1px solid ${N}`,
        fontFamily: "'DM Sans', sans-serif"
      },
      onMouseDown: p,
      children: /* @__PURE__ */ M(ie, { style: { flex: 1, minHeight: 0 }, children: [
        /* @__PURE__ */ M(
          "div",
          {
            style: {
              width: mr,
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              background: X,
              borderRight: `1px solid ${N}`
            },
            children: [
              /* @__PURE__ */ m("div", { style: { height: q, flexShrink: 0, borderBottom: `1px solid ${N}` } }),
              /* @__PURE__ */ m(
                "div",
                {
                  ref: n,
                  className: "timeline-sidebar-scroll",
                  style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: "auto",
                    borderBottom: a != null && a.length ? "none" : `1px solid ${N}`
                  },
                  children: a.map((f, g) => /* @__PURE__ */ m(Ii, { trackId: f.id, displayIndex: g, children: /* @__PURE__ */ m(ji, { track: f }) }, f.id))
                }
              ),
              r > 0 && /* @__PURE__ */ m("div", { style: { height: bt, flexShrink: 0 } })
            ]
          }
        ),
        /* @__PURE__ */ M(
          "div",
          {
            ref: e,
            style: {
              position: "relative",
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              cursor: "pointer",
              userSelect: "none"
            },
            onMouseDown: v,
            children: [
              /* @__PURE__ */ M(
                "div",
                {
                  style: {
                    position: "relative",
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column"
                  },
                  children: [
                    /* @__PURE__ */ m(Ai, {}),
                    /* @__PURE__ */ m(
                      "div",
                      {
                        ref: t,
                        className: "timeline-tracks-scroll",
                        style: {
                          flex: 1,
                          minHeight: 0,
                          overflowY: "auto"
                        },
                        children: /* @__PURE__ */ m("div", { style: { position: "relative" }, children: a.length === 0 ? /* @__PURE__ */ m(
                          "div",
                          {
                            style: {
                              position: "relative",
                              height: ut,
                              background: X,
                              borderBottom: `1px solid ${N}`,
                              boxSizing: "border-box"
                            }
                          }
                        ) : a.map((f) => /* @__PURE__ */ m(Pi, { track: f, isSelected: f.id === u }, f.id)) })
                      }
                    ),
                    /* @__PURE__ */ m(Mi, {}),
                    /* @__PURE__ */ m(Oi, {})
                  ]
                }
              ),
              r > 0 && /* @__PURE__ */ M(
                ie,
                {
                  style: {
                    height: bt,
                    flexShrink: 0,
                    borderTop: `1px solid ${N}`,
                    padding: `0 ${gn}px`
                  },
                  children: [
                    /* @__PURE__ */ m("div", { style: { width: pn, flexShrink: 0 }, children: /* @__PURE__ */ m(Li, {}) }),
                    /* @__PURE__ */ m(Ei, {})
                  ]
                }
              )
            ]
          }
        )
      ] })
    }
  );
}
export {
  ut as DEFAULT_TRACK_HEIGHT,
  $i as PLAYBACK_CONTROLS_HEIGHT,
  Ui as PlaybackControls,
  q as RULER_HEIGHT,
  bt as SCROLLBAR_AREA_HEIGHT,
  Kr as TimecodeInput,
  Yi as Timeline,
  Xi as TimelineProvider,
  Nr as secondsToTimecodeFrame,
  Zi as timecodeFrameToSeconds
};
